import {BaseApi} from "@/core/api/base.api";
import {Room} from "@/core/api/room.api";
import {roomGroupApi} from "@/core/api/room.group.api";

export class RoomCallMixerLayout extends BaseApi {
    constructor() {
        super();
    }

    getMixingLayout(layoutType) {
        return MixingLayoutType[layoutType];
    }

    getMixingLayoutRectList(layoutType, video_width, video_height, view_width, view_height, layoutMarginTop = undefined){
        // let rectList = !!combineLayoutType && MixingLayoutType[layoutType] ? MixingLayoutType[layoutType].concat(MixingLayoutType[combineLayoutType]) :MixingLayoutType[layoutType];
        let rectList =  MixingLayoutType[layoutType];
        if(!rectList) {
            return null;
        }
        view_width = view_width || video_width;
        view_height = view_height || video_height;

        let ratio,
            marginLeft=0, marginTop=0;

        if(video_width > video_height){
            ratio = view_width / video_width;
            if(video_height * ratio > view_height){
                ratio = null;
            }else{
                marginTop = (view_height - (video_height*ratio)) / 2;
            }
        }

        if(layoutMarginTop != undefined && !Number.isNaN(layoutMarginTop)) {
            marginTop = layoutMarginTop
        }
        if(!ratio){
            ratio = view_height / video_height;
            marginLeft = (view_width - (video_width*ratio)) / 2;
        }

        let film_height = {};
        function calc(base_rate){
            let left = parseInt(video_width * base_rate[0]);
            let top = parseInt(video_height * base_rate[1]);
            let right = parseInt(video_width * (base_rate[0] + base_rate[2]));
            let bottom = parseInt(video_height * (base_rate[1] + base_rate[3]));

            if(left % 2 === 1){
                left++;
            }
            if(top % 2 === 1){
                top++;
            }

            right -= left;
            bottom -= top;

            let obj =  {
                left: left * ratio + marginLeft,
                top: top * ratio + marginTop,
                width: (right%2===1 ? right+1 : right) * ratio,
                height: (bottom%2===1 ? bottom+1 : bottom) * ratio,
                pip: !!base_rate.pip,
                vip: !!base_rate.vip,
                vad: !!base_rate.vad,
                empty: !!base_rate.empty,
                clone: !!base_rate.clone,
                screenshare: !!base_rate.screenshare,
            }

            if(layoutType.includes('ml_custom_film_hor_')) {
                // film 레이아웃은 16:9 비율로 정함
                if(!film_height[top]){
                    film_height[top] = obj.width * 9 / 16;
                }
                obj.height = film_height[top];
            }
            return obj;
        }

        // let eduCallMode = true; // Room.isEduCallMode();
        let noContentRoomGroupMode  = Room.isRoomGroupMode() && roomGroupApi.noContentGroupMode()

        let len = rectList.length;
        let list = Object.assign([], {
            left: 9999, top: 9999,
            right: -9999, bottom: -9999
        });

        for(let i=0; i<len; i++){
            let rect = calc(rectList[i]);
            rect.idx = i;
            if(noContentRoomGroupMode) {
                if(rect.vip || rect.vad) {
                    continue;
                }
            }
            list[i] = rect;

            if(!list.hasPIP && rect.pip){
                list.hasPIP = true;
            }

            list.left = Math.min(list.left, rect.left);
            list.right = Math.max(list.right, rect.left + rect.width);
            list.top = Math.min(list.top, rect.top);
            list.bottom = Math.max(list.bottom, rect.top + rect.height);
        }

        list.width = list.right - list.left;
        list.height = list.bottom - list.top;
        return list;
    }


}

const MixingLayoutType = {};

// normal : 1 ~ 10
Object.assign(MixingLayoutType, {
    ml_01_00 : [ [ 0.0, 0.0, 1.0, 1.0 ] ],
    ml_02_00 : [ [ 0.0, 0.25, 0.5, 0.5 ], [ 0.5, 0.25, 0.5, 0.5 ] ],
    ml_02_01 : [ [ 0.0, 0.0, 1.0, 1.0 ], [ 0.4, 0.78, 0.2, 0.2, true ] ],
    ml_02_03 : [ [ 0.0, 0.0, 1.0, 0.5 ], [ 0.0, 0.5, 1.0, 0.5 ] ],
    ml_03_00 : [ [ 0.25, 0.0, 0.5, 0.5 ], [ 0.0, 0.5, 0.5, 0.5 ],
        [ 0.5, 0.5, 0.5, 0.5 ] ],
    ml_03_01 : [ [ 0.0, 0.0, 1.0, 1.0 ], [ 0.29, 0.78, 0.2, 0.2, true ],
        [ 0.50, 0.78, 0.2, 0.2, true ] ],
    ml_04_00 : [ [ 0.0, 0.0, 0.5, 0.5 ], [ 0.5, 0.0, 0.5, 0.5 ],
        [ 0.0, 0.5, 0.5, 0.5 ], [ 0.5, 0.5, 0.5, 0.5 ] ],
    ml_04_01 : [ [ 0.0, 0.0, 1.0, 1.0 ], [ 0.19, 0.78, 0.2, 0.2, true ],
        [ 0.40, 0.78, 0.2, 0.2, true ], [ 0.61, 0.78, 0.2, 0.2, true ] ],
    ml_05_00 : [ [ 0.0, 0.0, 0.5, 0.5 ], [ 0.5, 0.0, 0.5, 0.5 ],
        [ 0.0, 0.5, 0.33, 0.5 ], [ 0.33, 0.5, 0.33, 0.5 ],
        [ 0.66, 0.5, 0.34, 0.5 ] ],
    ml_05_01: [
        [ 0.0, 0.5,	1.0, 0.5 ],
        [ 0.0, 0.0, 0.25, 0.5 ],
        [ 0.25,	0.0, 0.25, 0.5 ],
        [ 0.5, 0.0, 0.25, 0.5 ],
        [ 0.75,	0.0, 0.25, 0.5 ]
    ],
    ml_06_00 : [ [ 0.0, 0.0, 0.66, 0.66 ], [ 0.66, 0.0, 0.34, 0.33 ],
        [ 0.66, 0.33, 0.34, 0.33 ], [ 0.0, 0.66, 0.33, 0.34 ],
        [ 0.33, 0.66, 0.33, 0.34 ], [ 0.66, 0.66, 0.34, 0.34 ] ],
    ml_07_00: [
        [ 0.0,      0.0,   0.5,   0.5 ],
        [ 0.5,      0.0,   0.5,   0.5 ],
        [ 0.0,      0.5,   0.5,   0.5 ],

        [ 0.5,      0.5,   0.25,   0.25 ],
        [ 0.75,   0.5,   0.25,   0.25 ],
        [ 0.5,      0.75,   0.25,   0.25 ],
        [ 0.75,   0.75,   0.25,   0.25 ]
    ],
    ml_08_00 : [
        [ 0.0,      0.0,   0.75, 0.75 ],
        [ 0.75,   0.0,   0.25, 0.25 ],
        [ 0.75,   0.25,   0.25, 0.25 ],
        [ 0.75,   0.50,   0.25, 0.25 ],
        [ 0.0,      0.75,   0.25, 0.25 ],
        [ 0.25,   0.75,   0.25, 0.25 ],
        [ 0.50,   0.75,   0.25, 0.25 ],
        [ 0.75,   0.75,   0.25, 0.25 ]
    ],
    ml_09_00 : [ [ 0.0, 0.0, 0.33, 0.33 ], [ 0.33, 0.0, 0.33, 0.33 ],
        [ 0.66, 0.0, 0.34, 0.33 ], [ 0.0, 0.33, 0.33, 0.33 ],
        [ 0.33, 0.33, 0.33, 0.33 ], [ 0.66, 0.33, 0.34, 0.33 ],
        [ 0.0, 0.66, 0.33, 0.34 ], [ 0.33, 0.66, 0.33, 0.34 ],
        [ 0.66, 0.66, 0.34, 0.34 ] ],
    ml_10_00 : [ [ 0.0, 0.0, 0.5, 0.5 ], [ 0.5, 0.0, 0.5, 0.5 ],
        [ 0.0, 0.5, 0.25, 0.25 ], [ 0.25, 0.5, 0.25, 0.25 ],
        [ 0.5, 0.5, 0.25, 0.25 ], [ 0.75, 0.5, 0.25, 0.25 ],
        [ 0.0, 0.75, 0.25, 0.25 ], [ 0.25, 0.75, 0.25, 0.25 ],
        [ 0.5, 0.75, 0.25, 0.25 ], [ 0.75, 0.75, 0.25, 0.25 ] ],
    ml_10_01 : [
        [ 0.0,      0.0,   0.80, 0.80 ],
        [ 0.80,   0.0,   0.20, 0.20 ],
        [ 0.80,   0.20,   0.20, 0.20 ],
        [ 0.80,   0.40,   0.20, 0.20 ],
        [ 0.80,   0.60,   0.20, 0.20 ],
        [ 0.0,      0.80,   0.20, 0.20 ],
        [ 0.20,   0.80,   0.20, 0.20 ],
        [ 0.40,   0.80,   0.20, 0.20 ],
        [ 0.60,   0.80,   0.20, 0.20 ],
        [ 0.80,   0.80,   0.20, 0.20 ]
    ],
});

// normal : 11 ~ 20
Object.assign(MixingLayoutType, {
    ml_11_00: [
        [ 0.0,      0.0,   0.33, 0.33 ],
        [ 0.33,   0.0,   0.33, 0.33 ],
        [ 0.66,   0.0,   0.34, 0.33 ],

        [ 0.0,      0.33,   0.25, 0.33 ],
        [ 0.25,   0.33,   0.25, 0.33 ],
        [ 0.5,      0.33,   0.25, 0.33 ],
        [ 0.75,   0.33,   0.25, 0.33 ],

        [ 0.0,      0.66,   0.25, 0.34 ],
        [ 0.25,   0.66,   0.25, 0.34 ],
        [ 0.5,      0.66,   0.25, 0.34 ],
        [ 0.75,   0.66,   0.25, 0.34 ]
    ],
    ml_11_01: [
        [ 0.0, 0.1, 1.0, 0.9 ],
        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ]
    ],
    ml_vad_11_00 : [
        [ 0.05, 0.0, 0.9, 0.9 ],
        [ 0.0, 0.9, 0.1, 0.1 ],
        [ 0.1, 0.9, 0.1, 0.1 ],
        [ 0.2, 0.9, 0.1, 0.1 ],
        [ 0.3, 0.9, 0.1, 0.1 ],
        [ 0.4, 0.9, 0.1, 0.1 ],
        [ 0.5, 0.9, 0.1, 0.1 ],
        [ 0.6, 0.9, 0.1, 0.1 ],
        [ 0.7, 0.9, 0.1, 0.1 ],
        [ 0.8, 0.9, 0.1, 0.1 ],
        [ 0.9, 0.9, 0.1, 0.1 ]
    ],
    ml_vad_11_01 : [
        [ 0.05, 0.1, 0.9, 0.9 ],

        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ]
    ],
    ml_12_00: [
        [ 0.0,      0.0,   0.25, 0.33 ],
        [ 0.25,   0.0,   0.25, 0.33 ],
        [ 0.5,      0.0,   0.25, 0.33 ],
        [ 0.75,   0.0,   0.25, 0.33 ],

        [ 0.0,      0.33,   0.25, 0.33 ],
        [ 0.25,   0.33,   0.25, 0.33 ],
        [ 0.5,      0.33,   0.25, 0.33 ],
        [ 0.75,   0.33,   0.25, 0.33 ],

        [ 0.0,      0.66,   0.25, 0.34 ],
        [ 0.25,   0.66,   0.25, 0.34 ],
        [ 0.5,      0.66,   0.25, 0.34 ],
        [ 0.75,   0.66,   0.25, 0.34 ]
    ],
    ml_12_01:[
        [ 0.0, 0.1,	0.5, 0.9 ],
        [ 0.5, 0.1,	0.5, 0.9 ],
        [ 0.0, 0.0,	0.1, 0.1 ],
        [ 0.1, 0.0,	0.1, 0.1 ],
        [ 0.2, 0.0,	0.1, 0.1 ],
        [ 0.3, 0.0,	0.1, 0.1 ],
        [ 0.4, 0.0,	0.1, 0.1 ],
        [ 0.5, 0.0,	0.1, 0.1 ],
        [ 0.6, 0.0,	0.1, 0.1 ],
        [ 0.7, 0.0,	0.1, 0.1 ],
        [ 0.8, 0.0,	0.1, 0.1 ],
        [ 0.9, 0.0,	0.1, 0.1 ]
    ],
    ml_13_00 : [ [ 0.0, 0.0, 0.5, 0.5 ], [ 0.5, 0.0, 0.25, 0.25 ],
        [ 0.75, 0.0, 0.25, 0.25 ], [ 0.5, 0.25, 0.25, 0.25 ],
        [ 0.75, 0.25, 0.25, 0.25 ],

        [ 0.0, 0.5, 0.25, 0.25 ], [ 0.25, 0.5, 0.25, 0.25 ],
        [ 0.5, 0.5, 0.25, 0.25 ], [ 0.75, 0.5, 0.25, 0.25 ],
        [ 0.0, 0.75, 0.25, 0.25 ], [ 0.25, 0.75, 0.25, 0.25 ],
        [ 0.5, 0.75, 0.25, 0.25 ], [ 0.75, 0.75, 0.25, 0.25 ] ],
    ml_14_00: [
        [ 0.0,		0.0,	0.2,	0.33 ],
        [ 0.2,		0.0,	0.2,	0.33 ],
        [ 0.4,		0.0,	0.2,	0.33 ],
        [ 0.6,		0.0,	0.2,	0.33 ],
        [ 0.8,		0.0,	0.2,	0.33 ],
        [ 0.0,		0.33,	0.2,	0.33 ],
        [ 0.2,		0.33,	0.2,	0.33 ],
        [ 0.4,		0.33,	0.2,	0.33 ],
        [ 0.6,		0.33,	0.2,	0.33 ],
        [ 0.8,		0.33,	0.2,	0.33 ],
        [ 0.0,		0.66,	0.25,	0.34 ],
        [ 0.25,	0.66,	0.25,	0.34 ],
        [ 0.5,		0.66,	0.25,	0.34 ],
        [ 0.75,	0.66,	0.25,	0.34 ]
    ],
    ml_15_00: [
        [ 0.0,		0.0,	0.2,	0.33 ],
        [ 0.2,		0.0,	0.2,	0.33 ],
        [ 0.4,		0.0,	0.2,	0.33 ],
        [ 0.6,		0.0,	0.2,	0.33 ],
        [ 0.8,		0.0,	0.2,	0.33 ],
        [ 0.0,		0.33,	0.2,	0.33 ],
        [ 0.2,		0.33,	0.2,	0.33 ],
        [ 0.4,		0.33,	0.2,	0.33 ],
        [ 0.6,		0.33,	0.2,	0.33 ],
        [ 0.8,		0.33,	0.2,	0.33 ],
        [ 0.0,		0.66,	0.2,	0.34 ],
        [ 0.2,		0.66,	0.2,	0.34 ],
        [ 0.4,		0.66,	0.2,	0.34 ],
        [ 0.6,		0.66,	0.2,	0.34 ],
        [ 0.8,		0.66,	0.2,	0.34 ]
    ],
    ml_16_00 : [ [ 0.0, 0.0, 0.25, 0.25 ], [ 0.25, 0.0, 0.25, 0.25 ],
        [ 0.5, 0.0, 0.25, 0.25 ], [ 0.75, 0.0, 0.25, 0.25 ],
        [ 0.0, 0.25, 0.25, 0.25 ], [ 0.25, 0.25, 0.25, 0.25 ],
        [ 0.5, 0.25, 0.25, 0.25 ], [ 0.75, 0.25, 0.25, 0.25 ],
        [ 0.0, 0.5, 0.25, 0.25 ], [ 0.25, 0.5, 0.25, 0.25 ],
        [ 0.5, 0.5, 0.25, 0.25 ], [ 0.75, 0.5, 0.25, 0.25 ],
        [ 0.0, 0.75, 0.25, 0.25 ], [ 0.25, 0.75, 0.25, 0.25 ],
        [ 0.5, 0.75, 0.25, 0.25 ], [ 0.75, 0.75, 0.25, 0.25 ] ],
    ml_17_00 : [
        [ 0.0, 0.0, 0.6, 0.6 ],

        [ 0.6, 0.0, 0.2, 0.2 ],
        [ 0.8, 0.0, 0.2, 0.2 ],

        [ 0.6, 0.2, 0.2, 0.2 ],
        [ 0.8, 0.2, 0.2, 0.2 ],

        [ 0.6, 0.4, 0.2, 0.2 ],
        [ 0.8, 0.4, 0.2, 0.2 ],

        [ 0.0, 0.6, 0.2, 0.2 ],
        [ 0.2, 0.6, 0.2, 0.2 ],
        [ 0.4, 0.6, 0.2, 0.2 ],
        [ 0.6, 0.6, 0.2, 0.2 ],
        [ 0.8, 0.6, 0.2, 0.2 ],

        [ 0.0, 0.8, 0.2, 0.2 ],
        [ 0.2, 0.8, 0.2, 0.2 ],
        [ 0.4, 0.8, 0.2, 0.2 ],
        [ 0.6, 0.8, 0.2, 0.2 ],
        [ 0.8, 0.8, 0.2, 0.2 ]
    ],
    ml_19_00 : [ [ 0.0, 0.0, 0.4, 0.4 ], [ 0.4, 0.0, 0.4, 0.4 ],
        [ 0.8, 0.0, 0.2, 0.2 ], [ 0.8, 0.2, 0.2, 0.2 ],

        [ 0.0, 0.4, 0.2, 0.2 ], [ 0.2, 0.4, 0.2, 0.2 ],
        [ 0.4, 0.4, 0.2, 0.2 ], [ 0.6, 0.4, 0.2, 0.2 ],
        [ 0.8, 0.4, 0.2, 0.2 ],

        [ 0.0, 0.6, 0.2, 0.2 ], [ 0.2, 0.6, 0.2, 0.2 ],
        [ 0.4, 0.6, 0.2, 0.2 ], [ 0.6, 0.6, 0.2, 0.2 ],
        [ 0.8, 0.6, 0.2, 0.2 ],

        [ 0.0, 0.8, 0.2, 0.2 ], [ 0.2, 0.8, 0.2, 0.2 ],
        [ 0.4, 0.8, 0.2, 0.2 ], [ 0.6, 0.8, 0.2, 0.2 ],
        [ 0.8, 0.8, 0.2, 0.2 ] ],
    ml_20_00: [
        [ 0.0,      0.0,   0.2, 0.25 ],
        [ 0.2,      0.0,   0.2, 0.25 ],
        [ 0.4,      0.0,   0.2, 0.25 ],
        [ 0.6,      0.0,   0.2, 0.25 ],
        [ 0.8,      0.0,   0.2, 0.25 ],

        [ 0.0,      0.25,   0.2, 0.25 ],
        [ 0.2,      0.25,   0.2, 0.25 ],
        [ 0.4,      0.25,   0.2, 0.25 ],
        [ 0.6,      0.25,   0.2, 0.25 ],
        [ 0.8,      0.25,   0.2, 0.25 ],

        [ 0.0,      0.5,   0.2, 0.25 ],
        [ 0.2,      0.5,   0.2, 0.25 ],
        [ 0.4,      0.5,   0.2, 0.25 ],
        [ 0.6,      0.5,   0.2, 0.25 ],
        [ 0.8,      0.5,   0.2, 0.25 ],

        [ 0.0,      0.75,   0.2, 0.25 ],
        [ 0.2,      0.75,   0.2, 0.25 ],
        [ 0.4,      0.75,   0.2, 0.25 ],
        [ 0.6,      0.75,   0.2, 0.25 ],
        [ 0.8,      0.75,   0.2, 0.25 ]
    ],
});

// normal : 21 ~ 40
Object.assign(MixingLayoutType, {
    ml_21_00: [
        [ 0.0, 0.2, 1.0, 0.8 ],

        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ],
        [ 0.0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ],
        [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ],
        [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ],
        [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ],
        [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ]
    ],
    ml_vad_21_00 : [
        [ 0.1, 0.0, 0.8, 0.8 ],

        [ 0.0, 0.8, 0.1, 0.1 ],
        [ 0.1, 0.8, 0.1, 0.1 ],
        [ 0.2, 0.8, 0.1, 0.1 ],
        [ 0.3, 0.8, 0.1, 0.1 ],
        [ 0.4, 0.8, 0.1, 0.1 ],
        [ 0.5, 0.8, 0.1, 0.1 ],
        [ 0.6, 0.8, 0.1, 0.1 ],
        [ 0.7, 0.8, 0.1, 0.1 ],
        [ 0.8, 0.8, 0.1, 0.1 ],
        [ 0.9, 0.8, 0.1, 0.1 ],

        [ 0.0, 0.9, 0.1, 0.1 ],
        [ 0.1, 0.9, 0.1, 0.1 ],
        [ 0.2, 0.9, 0.1, 0.1 ],
        [ 0.3, 0.9, 0.1, 0.1 ],
        [ 0.4, 0.9, 0.1, 0.1 ],
        [ 0.5, 0.9, 0.1, 0.1 ],
        [ 0.6, 0.9, 0.1, 0.1 ],
        [ 0.7, 0.9, 0.1, 0.1 ],
        [ 0.8, 0.9, 0.1, 0.1 ],
        [ 0.9, 0.9, 0.1, 0.1 ]
    ],
    ml_vad_21_01 : [
        [ 0.1, 0.2, 0.8, 0.8 ],

        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ],

        [ 0.0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ],
        [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ],
        [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ],
        [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ],
        [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ]
    ],
    ml_22_00 : [ [ 0.0, 0.0, 0.4, 0.4 ], [ 0.4, 0.0, 0.2, 0.2 ],
        [ 0.6, 0.0, 0.2, 0.2 ], [ 0.8, 0.0, 0.2, 0.2 ],
        [ 0.4, 0.2, 0.2, 0.2 ], [ 0.6, 0.2, 0.2, 0.2 ],
        [ 0.8, 0.2, 0.2, 0.2 ],

        [ 0.0, 0.4, 0.2, 0.2 ], [ 0.2, 0.4, 0.2, 0.2 ],
        [ 0.4, 0.4, 0.2, 0.2 ], [ 0.6, 0.4, 0.2, 0.2 ],
        [ 0.8, 0.4, 0.2, 0.2 ],

        [ 0.0, 0.6, 0.2, 0.2 ], [ 0.2, 0.6, 0.2, 0.2 ],
        [ 0.4, 0.6, 0.2, 0.2 ], [ 0.6, 0.6, 0.2, 0.2 ],
        [ 0.8, 0.6, 0.2, 0.2 ],

        [ 0.0, 0.8, 0.2, 0.2 ], [ 0.2, 0.8, 0.2, 0.2 ],
        [ 0.4, 0.8, 0.2, 0.2 ], [ 0.6, 0.8, 0.2, 0.2 ],
        [ 0.8, 0.8, 0.2, 0.2 ] ],
    ml_22_01 : [
        [ 0.0, 0.2,	0.5, 0.8 ],
        [ 0.5, 0.2,	0.5, 0.8 ],
        [ 0.0, 0.0,	0.1, 0.1 ],
        [ 0.1, 0.0,	0.1, 0.1 ],
        [ 0.2, 0.0,	0.1, 0.1 ],
        [ 0.3, 0.0,	0.1, 0.1 ],
        [ 0.4, 0.0,	0.1, 0.1 ],
        [ 0.5, 0.0,	0.1, 0.1 ],
        [ 0.6, 0.0,	0.1, 0.1 ],
        [ 0.7, 0.0,	0.1, 0.1 ],
        [ 0.8, 0.0,	0.1, 0.1 ],
        [ 0.9, 0.0,	0.1, 0.1 ],
        [ 0.0, 0.1,	0.1, 0.1 ],
        [ 0.1, 0.1,	0.1, 0.1 ],
        [ 0.2, 0.1,	0.1, 0.1 ],
        [ 0.3, 0.1,	0.1, 0.1 ],
        [ 0.4, 0.1,	0.1, 0.1 ],
        [ 0.5, 0.1,	0.1, 0.1 ],
        [ 0.6, 0.1,	0.1, 0.1 ],
        [ 0.7, 0.1,	0.1, 0.1 ],
        [ 0.8, 0.1,	0.1, 0.1 ],
        [ 0.9, 0.1,	0.1, 0.1 ]
    ],
    ml_25_00 : [ [ 0.0, 0.0, 0.2, 0.2 ], [ 0.2, 0.0, 0.2, 0.2 ],
        [ 0.4, 0.0, 0.2, 0.2 ], [ 0.6, 0.0, 0.2, 0.2 ],
        [ 0.8, 0.0, 0.2, 0.2 ], [ 0.0, 0.2, 0.2, 0.2 ],
        [ 0.2, 0.2, 0.2, 0.2 ], [ 0.4, 0.2, 0.2, 0.2 ],
        [ 0.6, 0.2, 0.2, 0.2 ], [ 0.8, 0.2, 0.2, 0.2 ],
        [ 0.0, 0.4, 0.2, 0.2 ], [ 0.2, 0.4, 0.2, 0.2 ],
        [ 0.4, 0.4, 0.2, 0.2 ], [ 0.6, 0.4, 0.2, 0.2 ],
        [ 0.8, 0.4, 0.2, 0.2 ], [ 0.0, 0.6, 0.2, 0.2 ],
        [ 0.2, 0.6, 0.2, 0.2 ], [ 0.4, 0.6, 0.2, 0.2 ],
        [ 0.6, 0.6, 0.2, 0.2 ], [ 0.8, 0.6, 0.2, 0.2 ],
        [ 0.0, 0.8, 0.2, 0.2 ], [ 0.2, 0.8, 0.2, 0.2 ],
        [ 0.4, 0.8, 0.2, 0.2 ], [ 0.6, 0.8, 0.2, 0.2 ],
        [ 0.8, 0.8, 0.2, 0.2 ] ],
    ml_30_00 : [ [ 0.0, 0.0, 0.332, 0.332 ], [ 0.332, 0.0, 0.332, 0.332 ],
        [ 0.664, 0.0, 0.166, 0.166 ], [ 0.830, 0.0, 0.170, 0.166 ],
        [ 0.664, 0.166, 0.166, 0.166 ], [ 0.830, 0.166, 0.170, 0.166 ],

        [ 0.0, 0.332, 0.166, 0.166 ], [ 0.166, 0.332, 0.166, 0.166 ],
        [ 0.332, 0.332, 0.166, 0.166 ], [ 0.498, 0.332, 0.166, 0.166 ],
        [ 0.664, 0.332, 0.166, 0.166 ], [ 0.830, 0.332, 0.170, 0.166 ],

        [ 0.0, 0.498, 0.166, 0.166 ], [ 0.166, 0.498, 0.166, 0.166 ],
        [ 0.332, 0.498, 0.166, 0.166 ], [ 0.498, 0.498, 0.166, 0.166 ],
        [ 0.664, 0.498, 0.166, 0.166 ], [ 0.830, 0.498, 0.170, 0.166 ],

        [ 0.0, 0.664, 0.166, 0.166 ], [ 0.166, 0.664, 0.166, 0.166 ],
        [ 0.332, 0.664, 0.166, 0.166 ], [ 0.498, 0.664, 0.166, 0.166 ],
        [ 0.664, 0.664, 0.166, 0.166 ], [ 0.830, 0.664, 0.170, 0.166 ],

        [ 0.0, 0.830, 0.166, 0.170 ], [ 0.166, 0.830, 0.166, 0.170 ],
        [ 0.332, 0.830, 0.166, 0.170 ], [ 0.498, 0.830, 0.166, 0.170 ],
        [ 0.664, 0.830, 0.166, 0.170 ], [ 0.830, 0.830, 0.170, 0.170 ] ],
    ml_31_00: [
        [ 0.0, 0.3, 1.0, 0.7 ],
        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ],
        [ 0.0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ],
        [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ],
        [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ],
        [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ],
        [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ],
        [ 0.0, 0.2, 0.1, 0.1 ],
        [ 0.1, 0.2, 0.1, 0.1 ],
        [ 0.2, 0.2, 0.1, 0.1 ],
        [ 0.3, 0.2, 0.1, 0.1 ],
        [ 0.4, 0.2, 0.1, 0.1 ],
        [ 0.5, 0.2, 0.1, 0.1 ],
        [ 0.6, 0.2, 0.1, 0.1 ],
        [ 0.7, 0.2, 0.1, 0.1 ],
        [ 0.8, 0.2, 0.1, 0.1 ],
        [ 0.9, 0.2, 0.1, 0.1 ]
    ],
    ml_31_01: [
        [ 0.0, 0.132, 1.0, 0.868 ],
        [ 0.0, 0.0,	0.066, 0.066 ],
        [ 0.066, 0.0, 0.066, 0.066 ],
        [ 0.132, 0.0, 0.066, 0.066 ],
        [ 0.198, 0.0, 0.066, 0.066 ],
        [ 0.264, 0.0, 0.066, 0.066 ],
        [ 0.330, 0.0, 0.066, 0.066 ],
        [ 0.396, 0.0, 0.066, 0.066 ],
        [ 0.462, 0.0, 0.066, 0.066 ],
        [ 0.528, 0.0, 0.066, 0.066 ],
        [ 0.594, 0.0, 0.066, 0.066 ],
        [ 0.660, 0.0, 0.066, 0.066 ],
        [ 0.726, 0.0, 0.066, 0.066 ],
        [ 0.792, 0.0, 0.066, 0.066 ],
        [ 0.858, 0.0, 0.066, 0.066 ],
        [ 0.924, 0.0, 0.076, 0.066 ],
        [ 0.0, 0.066, 0.066, 0.066 ],
        [ 0.066, 0.066,	0.066, 0.066 ],
        [ 0.132, 0.066,	0.066, 0.066 ],
        [ 0.198, 0.066,	0.066, 0.066 ],
        [ 0.264, 0.066,	0.066, 0.066 ],
        [ 0.330, 0.066,	0.066, 0.066 ],
        [ 0.396, 0.066,	0.066, 0.066 ],
        [ 0.462, 0.066,	0.066, 0.066 ],
        [ 0.528, 0.066,	0.066, 0.066 ],
        [ 0.594, 0.066,	0.066, 0.066 ],
        [ 0.660, 0.066,	0.066, 0.066 ],
        [ 0.726, 0.066,	0.066, 0.066 ],
        [ 0.792, 0.066,	0.066, 0.066 ],
        [ 0.858, 0.066,	0.066, 0.066 ],
        [ 0.924, 0.066,	0.076, 0.066 ]
    ],
    ml_32_00 : [
        [ 0.0,0.3,	0.5, 0.7 ],
        [ 0.5,0.3,	0.5, 0.7 ],
        [ 0.0,0.0,	0.1, 0.1 ],
        [ 0.1,0.0,	0.1, 0.1 ],
        [ 0.2,0.0,	0.1, 0.1 ],
        [ 0.3,0.0,	0.1, 0.1 ],
        [ 0.4,0.0,	0.1, 0.1 ],
        [ 0.5,0.0,	0.1, 0.1 ],
        [ 0.6,0.0,	0.1, 0.1 ],
        [ 0.7,0.0,	0.1, 0.1 ],
        [ 0.8,0.0,	0.1, 0.1 ],
        [ 0.9,0.0,	0.1, 0.1 ],
        [ 0.0,0.1,	0.1, 0.1 ],
        [ 0.1,0.1,	0.1, 0.1 ],
        [ 0.2,0.1,	0.1, 0.1 ],
        [ 0.3,0.1,	0.1, 0.1 ],
        [ 0.4,0.1,	0.1, 0.1 ],
        [ 0.5,0.1,	0.1, 0.1 ],
        [ 0.6,0.1,	0.1, 0.1 ],
        [ 0.7,0.1,	0.1, 0.1 ],
        [ 0.8,0.1,	0.1, 0.1 ],
        [ 0.9,0.1,	0.1, 0.1 ],
        [ 0.0,0.2,	0.1, 0.1 ],
        [ 0.1,0.2,	0.1, 0.1 ],
        [ 0.2,0.2,	0.1, 0.1 ],
        [ 0.3,0.2,	0.1, 0.1 ],
        [ 0.4,0.2,	0.1, 0.1 ],
        [ 0.5,0.2,	0.1, 0.1 ],
        [ 0.6,0.2,	0.1, 0.1 ],
        [ 0.7,0.2,	0.1, 0.1 ],
        [ 0.8,0.2,	0.1, 0.1 ],
        [ 0.9,0.2,	0.1, 0.1 ]
    ],
    ml_32_01 : [
        [ 0.0,0.132,	0.5, 	0.868 ],
        [ 0.5,0.132,	0.5, 	0.868 ],
        [ 0.0,0.0,	0.066, 	0.066 ],
        [ 0.066, 0.0,	0.066, 	0.066 ],
        [ 0.132, 0.0,	0.066, 	0.066 ],
        [ 0.198, 0.0,	0.066, 	0.066 ],
        [ 0.264, 0.0,	0.066, 	0.066 ],
        [ 0.330, 0.0,	0.066, 	0.066 ],
        [ 0.396, 0.0,	0.066, 	0.066 ],
        [ 0.462, 0.0,	0.066, 	0.066 ],
        [ 0.528, 0.0,	0.066, 	0.066 ],
        [ 0.594, 0.0,	0.066, 	0.066 ],
        [ 0.660, 0.0,	0.066, 	0.066 ],
        [ 0.726, 0.0,	0.066, 	0.066 ],
        [ 0.792, 0.0,	0.066,	0.066 ],
        [ 0.858, 0.0,	0.066,	0.066 ],
        [ 0.924, 0.0,	0.076, 	0.066 ],
        [ 0.0, 0.066,	0.066, 	0.066 ],
        [ 0.066, 0.066,	0.066, 	0.066 ],
        [ 0.132, 0.066,	0.066, 	0.066 ],
        [ 0.198, 0.066,	0.066, 	0.066 ],
        [ 0.264, 0.066,	0.066, 	0.066 ],
        [ 0.330, 0.066,	0.066, 	0.066 ],
        [ 0.396, 0.066,	0.066, 	0.066 ],
        [ 0.462, 0.066,	0.066, 	0.066 ],
        [ 0.528, 0.066,	0.066, 	0.066 ],
        [ 0.594, 0.066,	0.066, 	0.066 ],
        [ 0.660, 0.066,	0.066, 	0.066 ],
        [ 0.726, 0.066,	0.066, 	0.066 ],
        [ 0.792, 0.066,	0.066, 	0.066 ],
        [ 0.858, 0.066,	0.066, 	0.066 ],
        [ 0.924, 0.066,	0.076, 	0.066 ]
    ],
    ml_33_00 : [ [ 0.0, 0.0, 0.332, 0.332 ], [ 0.332, 0.0, 0.166, 0.166 ],
        [ 0.498, 0.0, 0.166, 0.166 ], [ 0.664, 0.0, 0.166, 0.166 ],
        [ 0.830, 0.0, 0.166, 0.166 ], [ 0.332, 0.166, 0.166, 0.166 ],
        [ 0.498, 0.166, 0.166, 0.166 ], [ 0.664, 0.166, 0.166, 0.166 ],
        [ 0.830, 0.166, 0.170, 0.166 ],

        [ 0.0, 0.332, 0.166, 0.166 ], [ 0.166, 0.332, 0.166, 0.166 ],
        [ 0.332, 0.332, 0.166, 0.166 ], [ 0.498, 0.332, 0.166, 0.166 ],
        [ 0.664, 0.332, 0.166, 0.166 ], [ 0.830, 0.332, 0.170, 0.166 ],

        [ 0.0, 0.498, 0.166, 0.166 ], [ 0.166, 0.498, 0.166, 0.166 ],
        [ 0.332, 0.498, 0.166, 0.166 ], [ 0.498, 0.498, 0.166, 0.166 ],
        [ 0.664, 0.498, 0.166, 0.166 ], [ 0.830, 0.498, 0.170, 0.166 ],

        [ 0.0, 0.664, 0.166, 0.166 ], [ 0.166, 0.664, 0.166, 0.166 ],
        [ 0.332, 0.664, 0.166, 0.166 ], [ 0.498, 0.664, 0.166, 0.166 ],
        [ 0.664, 0.664, 0.166, 0.166 ], [ 0.830, 0.664, 0.170, 0.166 ],

        [ 0.0, 0.830, 0.166, 0.170 ], [ 0.166, 0.830, 0.166, 0.170 ],
        [ 0.332, 0.830, 0.166, 0.170 ], [ 0.498, 0.830, 0.166, 0.170 ],
        [ 0.664, 0.830, 0.166, 0.170 ], [ 0.830, 0.830, 0.170, 0.170 ] ],
    ml_36_00 : [ [ 0.0, 0.0, 0.166, 0.166 ], [ 0.166, 0.0, 0.166, 0.166 ],
        [ 0.332, 0.0, 0.166, 0.166 ], [ 0.498, 0.0, 0.166, 0.166 ],
        [ 0.664, 0.0, 0.166, 0.166 ], [ 0.830, 0.0, 0.170, 0.166 ],

        [ 0.0, 0.166, 0.166, 0.166 ], [ 0.166, 0.166, 0.166, 0.166 ],
        [ 0.332, 0.166, 0.166, 0.166 ], [ 0.498, 0.166, 0.166, 0.166 ],
        [ 0.664, 0.166, 0.166, 0.166 ], [ 0.830, 0.166, 0.170, 0.166 ],

        [ 0.0, 0.332, 0.166, 0.166 ], [ 0.166, 0.332, 0.166, 0.166 ],
        [ 0.332, 0.332, 0.166, 0.166 ], [ 0.498, 0.332, 0.166, 0.166 ],
        [ 0.664, 0.332, 0.166, 0.166 ], [ 0.830, 0.332, 0.170, 0.166 ],

        [ 0.0, 0.498, 0.166, 0.166 ], [ 0.166, 0.498, 0.166, 0.166 ],
        [ 0.332, 0.498, 0.166, 0.166 ], [ 0.498, 0.498, 0.166, 0.166 ],
        [ 0.664, 0.498, 0.166, 0.166 ], [ 0.830, 0.498, 0.170, 0.166 ],

        [ 0.0, 0.664, 0.166, 0.166 ], [ 0.166, 0.664, 0.166, 0.166 ],
        [ 0.332, 0.664, 0.166, 0.166 ], [ 0.498, 0.664, 0.166, 0.166 ],
        [ 0.664, 0.664, 0.166, 0.166 ], [ 0.830, 0.664, 0.170, 0.166 ],

        [ 0.0, 0.830, 0.166, 0.170 ], [ 0.166, 0.830, 0.166, 0.170 ],
        [ 0.332, 0.830, 0.166, 0.170 ], [ 0.498, 0.830, 0.166, 0.170 ],
        [ 0.664, 0.830, 0.166, 0.170 ], [ 0.830, 0.830, 0.170, 0.170 ] ],
    ml_40_00: [
        [ 0.0, 0.0, 0.625, 0.625 ],
        [ 0.625, 0.0, 0.125, 0.125 ],
        [ 0.750, 0.0, 0.125, 0.125 ],
        [ 0.875, 0.0, 0.125, 0.125 ],
        [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ],
        [ 0.875, 0.125, 0.125, 0.125 ],
        [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ],
        [ 0.875, 0.250, 0.125, 0.125 ],
        [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ],
        [ 0.875, 0.375, 0.125, 0.125 ],
        [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ],
        [ 0.875, 0.500, 0.125, 0.125 ],
        [ 0.0,   0.625, 0.125, 0.125 ],
        [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ],
        [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ],
        [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ],
        [ 0.875, 0.625, 0.125, 0.125 ],
        [ 0.0,   0.750, 0.125, 0.125 ],
        [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ],
        [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ],
        [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ],
        [ 0.875, 0.750, 0.125, 0.125 ],
        [ 0.0,   0.875, 0.125, 0.125 ],
        [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ],
        [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ],
        [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ],
        [ 0.875, 0.875, 0.125, 0.125 ]
    ],
});

// normal : 41 ~ 100
Object.assign(MixingLayoutType, {
    ml_41_00: [
        [ 0.0, 0.4, 1.0, 0.6 ],
        [ 0.0, 0.0, 0.1, 0.1 ],
        [ 0.1, 0.0, 0.1, 0.1 ],
        [ 0.2, 0.0, 0.1, 0.1 ],
        [ 0.3, 0.0, 0.1, 0.1 ],
        [ 0.4, 0.0, 0.1, 0.1 ],
        [ 0.5, 0.0, 0.1, 0.1 ],
        [ 0.6, 0.0, 0.1, 0.1 ],
        [ 0.7, 0.0, 0.1, 0.1 ],
        [ 0.8, 0.0, 0.1, 0.1 ],
        [ 0.9, 0.0, 0.1, 0.1 ],
        [ 0.0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ],
        [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ],
        [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ],
        [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ],
        [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ],
        [ 0.0, 0.2, 0.1, 0.1 ],
        [ 0.1, 0.2, 0.1, 0.1 ],
        [ 0.2, 0.2, 0.1, 0.1 ],
        [ 0.3, 0.2, 0.1, 0.1 ],
        [ 0.4, 0.2, 0.1, 0.1 ],
        [ 0.5, 0.2, 0.1, 0.1 ],
        [ 0.6, 0.2, 0.1, 0.1 ],
        [ 0.7, 0.2, 0.1, 0.1 ],
        [ 0.8, 0.2, 0.1, 0.1 ],
        [ 0.9, 0.2, 0.1, 0.1 ],
        [ 0.0, 0.3, 0.1, 0.1 ],
        [ 0.1, 0.3, 0.1, 0.1 ],
        [ 0.2, 0.3, 0.1, 0.1 ],
        [ 0.3, 0.3, 0.1, 0.1 ],
        [ 0.4, 0.3, 0.1, 0.1 ],
        [ 0.5, 0.3, 0.1, 0.1 ],
        [ 0.6, 0.3, 0.1, 0.1 ],
        [ 0.7, 0.3, 0.1, 0.1 ],
        [ 0.8, 0.3, 0.1, 0.1 ],
        [ 0.9, 0.3, 0.1, 0.1 ]
    ],
    ml_41_01: [
        [ 0.0, 0.1,	1.0, 0.9 ],
        [ 0.0, 0.0,	0.05, 0.05 ],
        [ 0.05,	0.0, 0.05, 0.05 ],
        [ 0.1, 0.0,	0.05, 0.05 ],
        [ 0.15,	0.0, 0.05, 0.05 ],
        [ 0.2, 0.0,	0.05, 0.05 ],
        [ 0.25,	0.0, 0.05, 0.05 ],
        [ 0.3, 0.0,	0.05, 0.05 ],
        [ 0.35,	0.0, 0.05, 0.05 ],
        [ 0.4, 0.0,	0.05, 0.05 ],
        [ 0.45,	0.0, 0.05, 0.05 ],
        [ 0.5, 0.0,	0.05, 0.05 ],
        [ 0.55,	0.0, 0.05, 0.05 ],
        [ 0.6, 0.0,	0.05, 0.05 ],
        [ 0.65,	0.0, 0.05, 0.05 ],
        [ 0.7, 0.0,	0.05, 0.05 ],
        [ 0.75,	0.0, 0.05, 0.05 ],
        [ 0.8, 0.0,	0.05, 0.05 ],
        [ 0.85,	0.0,0.05, 0.05 ],
        [ 0.9, 0.0,	0.05, 0.05 ],
        [ 0.95,	0.0, 0.05, 0.05 ],
        [ 0.0, 0.05, 0.05, 0.05 ],
        [ 0.05,	0.05, 0.05, 0.05 ],
        [ 0.1, 0.05, 0.05, 0.05 ],
        [ 0.15,	0.05, 0.05, 0.05 ],
        [ 0.2, 0.05, 0.05, 0.05 ],
        [ 0.25,	0.05, 0.05, 0.05 ],
        [ 0.3, 0.05, 0.05, 0.05 ],
        [ 0.35,	0.05, 0.05, 0.05 ],
        [ 0.4, 0.05, 0.05, 0.05 ],
        [ 0.45,	0.05, 0.05, 0.05 ],
        [ 0.5, 0.05, 0.05, 0.05 ],
        [ 0.55,	0.05, 0.05, 0.05 ],
        [ 0.6, 0.05, 0.05, 0.05 ],
        [ 0.65,	0.05, 0.05, 0.05 ],
        [ 0.7, 0.05, 0.05, 0.05 ],
        [ 0.75,	0.05, 0.05, 0.05 ],
        [ 0.8, 0.05, 0.05, 0.05 ],
        [ 0.85,	0.05, 0.05, 0.05 ],
        [ 0.9, 0.05, 0.05, 0.05 ],
        [ 0.95,	0.05, 0.05, 0.05 ]
    ],
    ml_42_00 : [
        [ 0.0,0.4,	0.5, 0.6 ],
        [ 0.5,0.4,	0.5, 0.6 ],
        [ 0.0,0.0,	0.1, 0.1 ],
        [ 0.1,0.0,	0.1, 0.1 ],
        [ 0.2,0.0,	0.1, 0.1 ],
        [ 0.3,0.0,	0.1, 0.1 ],
        [ 0.4,0.0,	0.1, 0.1 ],
        [ 0.5,0.0,	0.1, 0.1 ],
        [ 0.6,0.0,	0.1, 0.1 ],
        [ 0.7,0.0,	0.1, 0.1 ],
        [ 0.8,0.0,	0.1, 0.1 ],
        [ 0.9,0.0,	0.1, 0.1 ],
        [ 0.0,0.1,	0.1, 0.1 ],
        [ 0.1,0.1,	0.1, 0.1 ],
        [ 0.2,0.1,	0.1, 0.1 ],
        [ 0.3,0.1,	0.1, 0.1 ],
        [ 0.4,0.1,	0.1, 0.1 ],
        [ 0.5,0.1,	0.1, 0.1 ],
        [ 0.6,0.1,	0.1, 0.1 ],
        [ 0.7,0.1,	0.1, 0.1 ],
        [ 0.8,0.1,	0.1, 0.1 ],
        [ 0.9,0.1,	0.1, 0.1 ],
        [ 0.0,0.2,	0.1, 0.1 ],
        [ 0.1,0.2,	0.1, 0.1 ],
        [ 0.2,0.2,	0.1, 0.1 ],
        [ 0.3,0.2,	0.1, 0.1 ],
        [ 0.4,0.2,	0.1, 0.1 ],
        [ 0.5,0.2,	0.1, 0.1 ],
        [ 0.6,0.2,	0.1, 0.1 ],
        [ 0.7,0.2,	0.1, 0.1 ],
        [ 0.8,0.2,	0.1, 0.1 ],
        [ 0.9,0.2,	0.1, 0.1 ],
        [ 0.0,0.3,	0.1, 0.1 ],
        [ 0.1,0.3,	0.1, 0.1 ],
        [ 0.2,0.3,	0.1, 0.1 ],
        [ 0.3,0.3,	0.1, 0.1 ],
        [ 0.4,0.3,	0.1, 0.1 ],
        [ 0.5,0.3,	0.1, 0.1 ],
        [ 0.6,0.3,	0.1, 0.1 ],
        [ 0.7,0.3,	0.1, 0.1 ],
        [ 0.8,0.3,	0.1, 0.1 ],
        [ 0.9,0.3,	0.1, 0.1 ]
    ],
    ml_42_01 : [
        [ 0.0, 0.1,	0.5, 0.9 ],
        [ 0.5, 0.1,	0.5, 0.9 ],
        [ 0.0, 0.0,	0.05, 0.05 ],
        [ 0.05,	0.0,	0.05, 0.05 ],
        [ 0.1,		0.0,	0.05, 0.05 ],
        [ 0.15,	0.0,	0.05, 0.05 ],
        [ 0.2,		0.0,	0.05, 0.05 ],
        [ 0.25,	0.0,	0.05, 0.05 ],
        [ 0.3,		0.0,	0.05, 0.05 ],
        [ 0.35,	0.0,	0.05, 0.05 ],
        [ 0.4,		0.0,	0.05, 0.05 ],
        [ 0.45,	0.0,	0.05, 0.05 ],
        [ 0.5,		0.0,	0.05, 0.05 ],
        [ 0.55,	0.0,	0.05, 0.05 ],
        [ 0.6,		0.0,	0.05, 0.05 ],
        [ 0.65,	0.0,	0.05, 0.05 ],
        [ 0.7,		0.0,	0.05, 0.05 ],
        [ 0.75,	0.0,	0.05, 0.05 ],
        [ 0.8,		0.0,	0.05, 0.05 ],
        [ 0.85,	0.0,	0.05, 0.05 ],
        [ 0.9,		0.0,	0.05, 0.05 ],
        [ 0.95,	0.0,	0.05, 0.05 ],
        [ 0.0,		0.05,	0.05, 0.05 ],
        [ 0.05,	0.05,	0.05, 0.05 ],
        [ 0.1,		0.05,	0.05, 0.05 ],
        [ 0.15,	0.05,	0.05, 0.05 ],
        [ 0.2,		0.05,	0.05, 0.05 ],
        [ 0.25,	0.05,	0.05, 0.05 ],
        [ 0.3,		0.05,	0.05, 0.05 ],
        [ 0.35,	0.05,	0.05, 0.05 ],
        [ 0.4,		0.05,	0.05, 0.05 ],
        [ 0.45,	0.05,	0.05, 0.05 ],
        [ 0.5,		0.05,	0.05, 0.05 ],
        [ 0.55,	0.05,	0.05, 0.05 ],
        [ 0.6,		0.05,	0.05, 0.05 ],
        [ 0.65,	0.05,	0.05, 0.05 ],
        [ 0.7,		0.05,	0.05, 0.05 ],
        [ 0.75,	0.05,	0.05, 0.05 ],
        [ 0.8,		0.05,	0.05, 0.05 ],
        [ 0.85,	0.05,	0.05, 0.05 ],
        [ 0.9,		0.05,	0.05, 0.05 ],
        [ 0.95,	0.05,	0.05, 0.05 ]
    ],
    ml_43_00 : [ [ 0.0, 0.0, 0.2856, 0.2856 ], [ 0.2856, 0.0, 0.2856, 0.2856 ],
        [ 0.5712, 0.0, 0.1428, 0.1428 ], [ 0.7140, 0.0, 0.1428, 0.1428 ],
        [ 0.8568, 0.0, 0.1428, 0.1428 ],
        [ 0.5712, 0.1428, 0.1428, 0.1428 ],
        [ 0.7140, 0.1428, 0.1428, 0.1428 ],
        [ 0.8568, 0.1428, 0.1428, 0.1428 ],

        [ 0.0, 0.2856, 0.1428, 0.1428 ],
        [ 0.1428, 0.2856, 0.1428, 0.1428 ],
        [ 0.2856, 0.2856, 0.1428, 0.1428 ],
        [ 0.4284, 0.2856, 0.1428, 0.1428 ],
        [ 0.5712, 0.2856, 0.1428, 0.1428 ],
        [ 0.7140, 0.2856, 0.1428, 0.1428 ],
        [ 0.8568, 0.2856, 0.1432, 0.1428 ],

        [ 0.0, 0.4284, 0.1428, 0.1428 ],
        [ 0.1428, 0.4284, 0.1428, 0.1428 ],
        [ 0.2856, 0.4284, 0.1428, 0.1428 ],
        [ 0.4284, 0.4284, 0.1428, 0.1428 ],
        [ 0.5712, 0.4284, 0.1428, 0.1428 ],
        [ 0.7140, 0.4284, 0.1428, 0.1428 ],
        [ 0.8568, 0.4284, 0.1432, 0.1428 ],

        [ 0.0, 0.5712, 0.1428, 0.1428 ],
        [ 0.1428, 0.5712, 0.1428, 0.1428 ],
        [ 0.2856, 0.5712, 0.1428, 0.1428 ],
        [ 0.4284, 0.5712, 0.1428, 0.1428 ],
        [ 0.5712, 0.5712, 0.1428, 0.1428 ],
        [ 0.7140, 0.5712, 0.1428, 0.1428 ],
        [ 0.8568, 0.5712, 0.1432, 0.1428 ],

        [ 0.0, 0.7140, 0.1428, 0.1428 ],
        [ 0.1428, 0.7140, 0.1428, 0.1428 ],
        [ 0.2856, 0.7140, 0.1428, 0.1428 ],
        [ 0.4284, 0.7140, 0.1428, 0.1428 ],
        [ 0.5712, 0.7140, 0.1428, 0.1428 ],
        [ 0.7140, 0.7140, 0.1428, 0.1428 ],
        [ 0.8568, 0.7140, 0.1432, 0.1428 ],

        [ 0.0, 0.8568, 0.1428, 0.1432 ],
        [ 0.1428, 0.8568, 0.1428, 0.1432 ],
        [ 0.2856, 0.8568, 0.1428, 0.1432 ],
        [ 0.4284, 0.8568, 0.1428, 0.1432 ],
        [ 0.5712, 0.8568, 0.1428, 0.1432 ],
        [ 0.7140, 0.8568, 0.1428, 0.1432 ],
        [ 0.8568, 0.8568, 0.1432, 0.1432 ] ],
    ml_46_00 : [ [ 0.0, 0.0, 0.2856, 0.2856 ], [ 0.2856, 0.0, 0.1428, 0.1428 ],
        [ 0.4284, 0.0, 0.1428, 0.1428 ], [ 0.5712, 0.0, 0.1428, 0.1428 ],
        [ 0.7140, 0.0, 0.1428, 0.1428 ], [ 0.8568, 0.0, 0.1428, 0.1428 ],
        [ 0.2856, 0.1428, 0.1428, 0.1428 ],
        [ 0.4284, 0.1428, 0.1428, 0.1428 ],
        [ 0.5712, 0.1428, 0.1428, 0.1428 ],
        [ 0.7140, 0.1428, 0.1428, 0.1428 ],
        [ 0.8568, 0.1428, 0.1428, 0.1428 ],

        [ 0.0, 0.2856, 0.1428, 0.1428 ],
        [ 0.1428, 0.2856, 0.1428, 0.1428 ],
        [ 0.2856, 0.2856, 0.1428, 0.1428 ],
        [ 0.4284, 0.2856, 0.1428, 0.1428 ],
        [ 0.5712, 0.2856, 0.1428, 0.1428 ],
        [ 0.7140, 0.2856, 0.1428, 0.1428 ],
        [ 0.8568, 0.2856, 0.1432, 0.1428 ],

        [ 0.0, 0.4284, 0.1428, 0.1428 ],
        [ 0.1428, 0.4284, 0.1428, 0.1428 ],
        [ 0.2856, 0.4284, 0.1428, 0.1428 ],
        [ 0.4284, 0.4284, 0.1428, 0.1428 ],
        [ 0.5712, 0.4284, 0.1428, 0.1428 ],
        [ 0.7140, 0.4284, 0.1428, 0.1428 ],
        [ 0.8568, 0.4284, 0.1432, 0.1428 ],

        [ 0.0, 0.5712, 0.1428, 0.1428 ],
        [ 0.1428, 0.5712, 0.1428, 0.1428 ],
        [ 0.2856, 0.5712, 0.1428, 0.1428 ],
        [ 0.4284, 0.5712, 0.1428, 0.1428 ],
        [ 0.5712, 0.5712, 0.1428, 0.1428 ],
        [ 0.7140, 0.5712, 0.1428, 0.1428 ],
        [ 0.8568, 0.5712, 0.1432, 0.1428 ],

        [ 0.0, 0.7140, 0.1428, 0.1428 ],
        [ 0.1428, 0.7140, 0.1428, 0.1428 ],
        [ 0.2856, 0.7140, 0.1428, 0.1428 ],
        [ 0.4284, 0.7140, 0.1428, 0.1428 ],
        [ 0.5712, 0.7140, 0.1428, 0.1428 ],
        [ 0.7140, 0.7140, 0.1428, 0.1428 ],
        [ 0.8568, 0.7140, 0.1432, 0.1428 ],

        [ 0.0, 0.8568, 0.1428, 0.1432 ],
        [ 0.1428, 0.8568, 0.1428, 0.1432 ],
        [ 0.2856, 0.8568, 0.1428, 0.1432 ],
        [ 0.4284, 0.8568, 0.1428, 0.1432 ],
        [ 0.5712, 0.8568, 0.1428, 0.1432 ],
        [ 0.7140, 0.8568, 0.1428, 0.1432 ],
        [ 0.8568, 0.8568, 0.1432, 0.1432 ] ],
    ml_49_00 : [ [ 0.0, 0.0, 0.1428, 0.1428 ], [ 0.1428, 0.0, 0.1428, 0.1428 ],
        [ 0.2856, 0.0, 0.1428, 0.1428 ], [ 0.4284, 0.0, 0.1428, 0.1428 ],
        [ 0.5712, 0.0, 0.1428, 0.1428 ], [ 0.7140, 0.0, 0.1428, 0.1428 ],
        [ 0.8568, 0.0, 0.1432, 0.1428 ],

        [ 0.0, 0.1428, 0.1428, 0.1428 ],
        [ 0.1428, 0.1428, 0.1428, 0.1428 ],
        [ 0.2856, 0.1428, 0.1428, 0.1428 ],
        [ 0.4284, 0.1428, 0.1428, 0.1428 ],
        [ 0.5712, 0.1428, 0.1428, 0.1428 ],
        [ 0.7140, 0.1428, 0.1428, 0.1428 ],
        [ 0.8568, 0.1428, 0.1432, 0.1428 ],

        [ 0.0, 0.2856, 0.1428, 0.1428 ],
        [ 0.1428, 0.2856, 0.1428, 0.1428 ],
        [ 0.2856, 0.2856, 0.1428, 0.1428 ],
        [ 0.4284, 0.2856, 0.1428, 0.1428 ],
        [ 0.5712, 0.2856, 0.1428, 0.1428 ],
        [ 0.7140, 0.2856, 0.1428, 0.1428 ],
        [ 0.8568, 0.2856, 0.1432, 0.1428 ],

        [ 0.0, 0.4284, 0.1428, 0.1428 ],
        [ 0.1428, 0.4284, 0.1428, 0.1428 ],
        [ 0.2856, 0.4284, 0.1428, 0.1428 ],
        [ 0.4284, 0.4284, 0.1428, 0.1428 ],
        [ 0.5712, 0.4284, 0.1428, 0.1428 ],
        [ 0.7140, 0.4284, 0.1428, 0.1428 ],
        [ 0.8568, 0.4284, 0.1432, 0.1428 ],

        [ 0.0, 0.5712, 0.1428, 0.1428 ],
        [ 0.1428, 0.5712, 0.1428, 0.1428 ],
        [ 0.2856, 0.5712, 0.1428, 0.1428 ],
        [ 0.4284, 0.5712, 0.1428, 0.1428 ],
        [ 0.5712, 0.5712, 0.1428, 0.1428 ],
        [ 0.7140, 0.5712, 0.1428, 0.1428 ],
        [ 0.8568, 0.5712, 0.1432, 0.1428 ],

        [ 0.0, 0.7140, 0.1428, 0.1428 ],
        [ 0.1428, 0.7140, 0.1428, 0.1428 ],
        [ 0.2856, 0.7140, 0.1428, 0.1428 ],
        [ 0.4284, 0.7140, 0.1428, 0.1428 ],
        [ 0.5712, 0.7140, 0.1428, 0.1428 ],
        [ 0.7140, 0.7140, 0.1428, 0.1428 ],
        [ 0.8568, 0.7140, 0.1432, 0.1428 ],

        [ 0.0, 0.8568, 0.1428, 0.1432 ],
        [ 0.1428, 0.8568, 0.1428, 0.1432 ],
        [ 0.2856, 0.8568, 0.1428, 0.1432 ],
        [ 0.4284, 0.8568, 0.1428, 0.1432 ],
        [ 0.5712, 0.8568, 0.1428, 0.1432 ],
        [ 0.7140, 0.8568, 0.1428, 0.1432 ],
        [ 0.8568, 0.8568, 0.1432, 0.1432 ] ],
    ml_49_01 : [
        [ 0.0,   0.0,   0.500, 0.500 ],
        [ 0.500, 0.0,   0.125, 0.125 ],
        [ 0.625, 0.0,   0.125, 0.125 ],
        [ 0.750, 0.0,   0.125, 0.125 ],
        [ 0.875, 0.0,   0.125, 0.125 ],
        [ 0.500, 0.125, 0.125, 0.125 ],
        [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ],
        [ 0.875, 0.125, 0.125, 0.125 ],
        [ 0.500, 0.250, 0.125, 0.125 ],
        [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ],
        [ 0.875, 0.250, 0.125, 0.125 ],
        [ 0.500, 0.375, 0.125, 0.125 ],
        [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ],
        [ 0.875, 0.375, 0.125, 0.125 ],
        [ 0.0,   0.500, 0.125, 0.125 ],
        [ 0.125, 0.500, 0.125, 0.125 ],
        [ 0.250, 0.500, 0.125, 0.125 ],
        [ 0.375, 0.500, 0.125, 0.125 ],
        [ 0.500, 0.500, 0.125, 0.125 ],
        [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ],
        [ 0.875, 0.500, 0.125, 0.125 ],
        [ 0.0,   0.625, 0.125, 0.125 ],
        [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ],
        [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ],
        [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ],
        [ 0.875, 0.625, 0.125, 0.125 ],
        [ 0.0,   0.750, 0.125, 0.125 ],
        [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ],
        [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ],
        [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ],
        [ 0.875, 0.750, 0.125, 0.125 ],
        [ 0.0,   0.875, 0.125, 0.125 ],
        [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ],
        [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ],
        [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ],
        [ 0.875, 0.875, 0.125, 0.125 ]
    ],
    ml_56_00 : [
        [ 0.0,   0.0,   0.375, 0.375 ],
        [ 0.375, 0.0,   0.125, 0.125 ],
        [ 0.500, 0.0,   0.125, 0.125 ],
        [ 0.625, 0.0,   0.125, 0.125 ],
        [ 0.750, 0.0,   0.125, 0.125 ],
        [ 0.875, 0.0,   0.125, 0.125 ],
        [ 0.375, 0.125, 0.125, 0.125 ],
        [ 0.500, 0.125, 0.125, 0.125 ],
        [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ],
        [ 0.875, 0.125, 0.125, 0.125 ],
        [ 0.375, 0.250, 0.125, 0.125 ],
        [ 0.500, 0.250, 0.125, 0.125 ],
        [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ],
        [ 0.875, 0.250, 0.125, 0.125 ],
        [ 0.0,   0.375, 0.125, 0.125 ],
        [ 0.125, 0.375, 0.125, 0.125 ],
        [ 0.250, 0.375, 0.125, 0.125 ],
        [ 0.375, 0.375, 0.125, 0.125 ],
        [ 0.500, 0.375, 0.125, 0.125 ],
        [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ],
        [ 0.875, 0.375, 0.125, 0.125 ],
        [ 0.0,   0.500, 0.125, 0.125 ],
        [ 0.125, 0.500, 0.125, 0.125 ],
        [ 0.250, 0.500, 0.125, 0.125 ],
        [ 0.375, 0.500, 0.125, 0.125 ],
        [ 0.500, 0.500, 0.125, 0.125 ],
        [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ],
        [ 0.875, 0.500, 0.125, 0.125 ],
        [ 0.0,   0.625, 0.125, 0.125 ],
        [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ],
        [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ],
        [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ],
        [ 0.875, 0.625, 0.125, 0.125 ],
        [ 0.0,   0.750, 0.125, 0.125 ],
        [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ],
        [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ],
        [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ],
        [ 0.875, 0.750, 0.125, 0.125 ],
        [ 0.0,   0.875, 0.125, 0.125 ],
        [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ],
        [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ],
        [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ],
        [ 0.875, 0.875, 0.125, 0.125 ] ],
    ml_58_00 : [ [ 0.0, 0.0, 0.250, 0.250 ], [ 0.250, 0.0, 0.250, 0.250 ],

        [ 0.500, 0.0, 0.125, 0.125 ], [ 0.625, 0.0, 0.125, 0.125 ],
        [ 0.750, 0.0, 0.125, 0.125 ], [ 0.875, 0.0, 0.125, 0.125 ],

        [ 0.500, 0.125, 0.125, 0.125 ], [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ], [ 0.875, 0.125, 0.125, 0.125 ],

        [ 0.0, 0.250, 0.125, 0.125 ], [ 0.125, 0.250, 0.125, 0.125 ],
        [ 0.250, 0.250, 0.125, 0.125 ], [ 0.375, 0.250, 0.125, 0.125 ],
        [ 0.500, 0.250, 0.125, 0.125 ], [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ], [ 0.875, 0.250, 0.125, 0.125 ],

        [ 0.0, 0.375, 0.125, 0.125 ], [ 0.125, 0.375, 0.125, 0.125 ],
        [ 0.250, 0.375, 0.125, 0.125 ], [ 0.375, 0.375, 0.125, 0.125 ],
        [ 0.500, 0.375, 0.125, 0.125 ], [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ], [ 0.875, 0.375, 0.125, 0.125 ],

        [ 0.0, 0.500, 0.125, 0.125 ], [ 0.125, 0.500, 0.125, 0.125 ],
        [ 0.250, 0.500, 0.125, 0.125 ], [ 0.375, 0.500, 0.125, 0.125 ],
        [ 0.500, 0.500, 0.125, 0.125 ], [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ], [ 0.875, 0.500, 0.125, 0.125 ],

        [ 0.0, 0.625, 0.125, 0.125 ], [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ], [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ], [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ], [ 0.875, 0.625, 0.125, 0.125 ],

        [ 0.0, 0.750, 0.125, 0.125 ], [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ], [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ], [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ], [ 0.875, 0.750, 0.125, 0.125 ],

        [ 0.0, 0.875, 0.125, 0.125 ], [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ], [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ], [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ], [ 0.875, 0.875, 0.125, 0.125 ] ],
    ml_61_00 : [ [ 0.0, 0.0, 0.250, 0.250 ],

        [ 0.250, 0.0, 0.125, 0.125 ], [ 0.375, 0.0, 0.125, 0.125 ],
        [ 0.500, 0.0, 0.125, 0.125 ], [ 0.625, 0.0, 0.125, 0.125 ],
        [ 0.750, 0.0, 0.125, 0.125 ], [ 0.875, 0.0, 0.125, 0.125 ],

        [ 0.250, 0.125, 0.125, 0.125 ], [ 0.375, 0.125, 0.125, 0.125 ],
        [ 0.500, 0.125, 0.125, 0.125 ], [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ], [ 0.875, 0.125, 0.125, 0.125 ],

        [ 0.0, 0.250, 0.125, 0.125 ], [ 0.125, 0.250, 0.125, 0.125 ],
        [ 0.250, 0.250, 0.125, 0.125 ], [ 0.375, 0.250, 0.125, 0.125 ],
        [ 0.500, 0.250, 0.125, 0.125 ], [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ], [ 0.875, 0.250, 0.125, 0.125 ],

        [ 0.0, 0.375, 0.125, 0.125 ], [ 0.125, 0.375, 0.125, 0.125 ],
        [ 0.250, 0.375, 0.125, 0.125 ], [ 0.375, 0.375, 0.125, 0.125 ],
        [ 0.500, 0.375, 0.125, 0.125 ], [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ], [ 0.875, 0.375, 0.125, 0.125 ],

        [ 0.0, 0.500, 0.125, 0.125 ], [ 0.125, 0.500, 0.125, 0.125 ],
        [ 0.250, 0.500, 0.125, 0.125 ], [ 0.375, 0.500, 0.125, 0.125 ],
        [ 0.500, 0.500, 0.125, 0.125 ], [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ], [ 0.875, 0.500, 0.125, 0.125 ],

        [ 0.0, 0.625, 0.125, 0.125 ], [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ], [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ], [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ], [ 0.875, 0.625, 0.125, 0.125 ],

        [ 0.0, 0.750, 0.125, 0.125 ], [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ], [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ], [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ], [ 0.875, 0.750, 0.125, 0.125 ],

        [ 0.0, 0.875, 0.125, 0.125 ], [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ], [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ], [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ], [ 0.875, 0.875, 0.125, 0.125 ] ],
    ml_64_00 : [ [ 0.0, 0.0, 0.125, 0.125 ], [ 0.125, 0.0, 0.125, 0.125 ],
        [ 0.250, 0.0, 0.125, 0.125 ], [ 0.375, 0.0, 0.125, 0.125 ],
        [ 0.500, 0.0, 0.125, 0.125 ], [ 0.625, 0.0, 0.125, 0.125 ],
        [ 0.750, 0.0, 0.125, 0.125 ], [ 0.875, 0.0, 0.125, 0.125 ],

        [ 0.0, 0.125, 0.125, 0.125 ], [ 0.125, 0.125, 0.125, 0.125 ],
        [ 0.250, 0.125, 0.125, 0.125 ], [ 0.375, 0.125, 0.125, 0.125 ],
        [ 0.500, 0.125, 0.125, 0.125 ], [ 0.625, 0.125, 0.125, 0.125 ],
        [ 0.750, 0.125, 0.125, 0.125 ], [ 0.875, 0.125, 0.125, 0.125 ],

        [ 0.0, 0.250, 0.125, 0.125 ], [ 0.125, 0.250, 0.125, 0.125 ],
        [ 0.250, 0.250, 0.125, 0.125 ], [ 0.375, 0.250, 0.125, 0.125 ],
        [ 0.500, 0.250, 0.125, 0.125 ], [ 0.625, 0.250, 0.125, 0.125 ],
        [ 0.750, 0.250, 0.125, 0.125 ], [ 0.875, 0.250, 0.125, 0.125 ],

        [ 0.0, 0.375, 0.125, 0.125 ], [ 0.125, 0.375, 0.125, 0.125 ],
        [ 0.250, 0.375, 0.125, 0.125 ], [ 0.375, 0.375, 0.125, 0.125 ],
        [ 0.500, 0.375, 0.125, 0.125 ], [ 0.625, 0.375, 0.125, 0.125 ],
        [ 0.750, 0.375, 0.125, 0.125 ], [ 0.875, 0.375, 0.125, 0.125 ],

        [ 0.0, 0.500, 0.125, 0.125 ], [ 0.125, 0.500, 0.125, 0.125 ],
        [ 0.250, 0.500, 0.125, 0.125 ], [ 0.375, 0.500, 0.125, 0.125 ],
        [ 0.500, 0.500, 0.125, 0.125 ], [ 0.625, 0.500, 0.125, 0.125 ],
        [ 0.750, 0.500, 0.125, 0.125 ], [ 0.875, 0.500, 0.125, 0.125 ],

        [ 0.0, 0.625, 0.125, 0.125 ], [ 0.125, 0.625, 0.125, 0.125 ],
        [ 0.250, 0.625, 0.125, 0.125 ], [ 0.375, 0.625, 0.125, 0.125 ],
        [ 0.500, 0.625, 0.125, 0.125 ], [ 0.625, 0.625, 0.125, 0.125 ],
        [ 0.750, 0.625, 0.125, 0.125 ], [ 0.875, 0.625, 0.125, 0.125 ],

        [ 0.0, 0.750, 0.125, 0.125 ], [ 0.125, 0.750, 0.125, 0.125 ],
        [ 0.250, 0.750, 0.125, 0.125 ], [ 0.375, 0.750, 0.125, 0.125 ],
        [ 0.500, 0.750, 0.125, 0.125 ], [ 0.625, 0.750, 0.125, 0.125 ],
        [ 0.750, 0.750, 0.125, 0.125 ], [ 0.875, 0.750, 0.125, 0.125 ],

        [ 0.0, 0.875, 0.125, 0.125 ], [ 0.125, 0.875, 0.125, 0.125 ],
        [ 0.250, 0.875, 0.125, 0.125 ], [ 0.375, 0.875, 0.125, 0.125 ],
        [ 0.500, 0.875, 0.125, 0.125 ], [ 0.625, 0.875, 0.125, 0.125 ],
        [ 0.750, 0.875, 0.125, 0.125 ], [ 0.875, 0.875, 0.125, 0.125 ] ],
    ml_81_00 : [
        [ 0.0,   0.0,   0.111, 0.111 ], [ 0.111, 0.0,   0.111, 0.111 ],
        [ 0.222, 0.0,   0.111, 0.111 ], [ 0.333, 0.0,   0.111, 0.111 ],
        [ 0.444, 0.0,   0.111, 0.111 ], [ 0.555, 0.0,   0.111, 0.111 ],
        [ 0.666, 0.0,   0.111, 0.111 ], [ 0.777, 0.0,   0.111, 0.111 ],
        [ 0.888, 0.0,   0.112, 0.111 ],
        [ 0.0,   0.111,   0.111, 0.111 ], [ 0.111, 0.111,   0.111, 0.111 ],
        [ 0.222, 0.111,   0.111, 0.111 ], [ 0.333, 0.111,   0.111, 0.111 ],
        [ 0.444, 0.111,   0.111, 0.111 ], [ 0.555, 0.111,   0.111, 0.111 ],
        [ 0.666, 0.111,   0.111, 0.111 ], [ 0.777, 0.111,   0.111, 0.111 ],
        [ 0.888, 0.111,   0.112, 0.111 ],
        [ 0.0,   0.222,   0.111, 0.111 ], [ 0.111, 0.222,   0.111, 0.111 ],
        [ 0.222, 0.222,   0.111, 0.111 ], [ 0.333, 0.222,   0.111, 0.111 ],
        [ 0.444, 0.222,   0.111, 0.111 ], [ 0.555, 0.222,   0.111, 0.111 ],
        [ 0.666, 0.222,   0.111, 0.111 ], [ 0.777, 0.222,   0.111, 0.111 ],
        [ 0.888, 0.222,   0.112, 0.111 ],
        [ 0.0,   0.333,   0.111, 0.111 ], [ 0.111, 0.333,   0.111, 0.111 ],
        [ 0.222, 0.333,   0.111, 0.111 ], [ 0.333, 0.333,   0.111, 0.111 ],
        [ 0.444, 0.333,   0.111, 0.111 ], [ 0.555, 0.333,   0.111, 0.111 ],
        [ 0.666, 0.333,   0.111, 0.111 ], [ 0.777, 0.333,   0.111, 0.111 ],
        [ 0.888, 0.333,   0.112, 0.111 ],
        [ 0.0,   0.444,   0.111, 0.111 ], [ 0.111, 0.444,   0.111, 0.111 ],
        [ 0.222, 0.444,   0.111, 0.111 ], [ 0.333, 0.444,   0.111, 0.111 ],
        [ 0.444, 0.444,   0.111, 0.111 ], [ 0.555, 0.444,   0.111, 0.111 ],
        [ 0.666, 0.444,   0.111, 0.111 ], [ 0.777, 0.444,   0.111, 0.111 ],
        [ 0.888, 0.444,   0.112, 0.111 ],
        [ 0.0,   0.555,   0.111, 0.111 ], [ 0.111, 0.555,   0.111, 0.111 ],
        [ 0.222, 0.555,   0.111, 0.111 ], [ 0.333, 0.555,   0.111, 0.111 ],
        [ 0.444, 0.555,   0.111, 0.111 ], [ 0.555, 0.555,   0.111, 0.111 ],
        [ 0.666, 0.555,   0.111, 0.111 ], [ 0.777, 0.555,   0.111, 0.111 ],
        [ 0.888, 0.555,   0.112, 0.111 ],
        [ 0.0,   0.666,   0.111, 0.111 ], [ 0.111, 0.666,   0.111, 0.111 ],
        [ 0.222, 0.666,   0.111, 0.111 ], [ 0.333, 0.666,   0.111, 0.111 ],
        [ 0.444, 0.666,   0.111, 0.111 ], [ 0.555, 0.666,   0.111, 0.111 ],
        [ 0.666, 0.666,   0.111, 0.111 ], [ 0.777, 0.666,   0.111, 0.111 ],
        [ 0.888, 0.666,   0.112, 0.111 ],
        [ 0.0,   0.777,   0.111, 0.111 ], [ 0.111, 0.777,   0.111, 0.111 ],
        [ 0.222, 0.777,   0.111, 0.111 ], [ 0.333, 0.777,   0.111, 0.111 ],
        [ 0.444, 0.777,   0.111, 0.111 ], [ 0.555, 0.777,   0.111, 0.111 ],
        [ 0.666, 0.777,   0.111, 0.111 ], [ 0.777, 0.777,   0.111, 0.111 ],
        [ 0.888, 0.777,   0.112, 0.111 ],
        [ 0.0,   0.888,   0.111, 0.112 ], [ 0.111, 0.888,   0.111, 0.112 ],
        [ 0.222, 0.888,   0.111, 0.112 ], [ 0.333, 0.888,   0.111, 0.112 ],
        [ 0.444, 0.888,   0.111, 0.112 ], [ 0.555, 0.888,   0.111, 0.112 ],
        [ 0.666, 0.888,   0.111, 0.112 ], [ 0.777, 0.888,   0.111, 0.112 ],
        [ 0.888, 0.888,   0.112, 0.112 ],
    ],
    ml_100_00 : [
        [ 0.0, 0.0,   0.1, 0.1 ], [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ], [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ], [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ], [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ], [ 0.9, 0.0,   0.1, 0.1 ],
        [ 0.0, 0.1,   0.1, 0.1 ], [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ], [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ], [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ], [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ], [ 0.9, 0.1,   0.1, 0.1 ],
        [ 0.0, 0.2,   0.1, 0.1 ], [ 0.1, 0.2,   0.1, 0.1 ],
        [ 0.2, 0.2,   0.1, 0.1 ], [ 0.3, 0.2,   0.1, 0.1 ],
        [ 0.4, 0.2,   0.1, 0.1 ], [ 0.5, 0.2,   0.1, 0.1 ],
        [ 0.6, 0.2,   0.1, 0.1 ], [ 0.7, 0.2,   0.1, 0.1 ],
        [ 0.8, 0.2,   0.1, 0.1 ], [ 0.9, 0.2,   0.1, 0.1 ],
        [ 0.0, 0.3,   0.1, 0.1 ], [ 0.1, 0.3,   0.1, 0.1 ],
        [ 0.2, 0.3,   0.1, 0.1 ], [ 0.3, 0.3,   0.1, 0.1 ],
        [ 0.4, 0.3,   0.1, 0.1 ], [ 0.5, 0.3,   0.1, 0.1 ],
        [ 0.6, 0.3,   0.1, 0.1 ], [ 0.7, 0.3,   0.1, 0.1 ],
        [ 0.8, 0.3,   0.1, 0.1 ], [ 0.9, 0.3,   0.1, 0.1 ],
        [ 0.0, 0.4,   0.1, 0.1 ], [ 0.1, 0.4,   0.1, 0.1 ],
        [ 0.2, 0.4,   0.1, 0.1 ], [ 0.3, 0.4,   0.1, 0.1 ],
        [ 0.4, 0.4,   0.1, 0.1 ], [ 0.5, 0.4,   0.1, 0.1 ],
        [ 0.6, 0.4,   0.1, 0.1 ], [ 0.7, 0.4,   0.1, 0.1 ],
        [ 0.8, 0.4,   0.1, 0.1 ], [ 0.9, 0.4,   0.1, 0.1 ],
        [ 0.0, 0.5,   0.1, 0.1 ], [ 0.1, 0.5,   0.1, 0.1 ],
        [ 0.2, 0.5,   0.1, 0.1 ], [ 0.3, 0.5,   0.1, 0.1 ],
        [ 0.4, 0.5,   0.1, 0.1 ], [ 0.5, 0.5,   0.1, 0.1 ],
        [ 0.6, 0.5,   0.1, 0.1 ], [ 0.7, 0.5,   0.1, 0.1 ],
        [ 0.8, 0.5,   0.1, 0.1 ], [ 0.9, 0.5,   0.1, 0.1 ],
        [ 0.0, 0.6,   0.1, 0.1 ], [ 0.1, 0.6,   0.1, 0.1 ],
        [ 0.2, 0.6,   0.1, 0.1 ], [ 0.3, 0.6,   0.1, 0.1 ],
        [ 0.4, 0.6,   0.1, 0.1 ], [ 0.5, 0.6,   0.1, 0.1 ],
        [ 0.6, 0.6,   0.1, 0.1 ], [ 0.7, 0.6,   0.1, 0.1 ],
        [ 0.8, 0.6,   0.1, 0.1 ], [ 0.9, 0.6,   0.1, 0.1 ],
        [ 0.0, 0.7,   0.1, 0.1 ], [ 0.1, 0.7,   0.1, 0.1 ],
        [ 0.2, 0.7,   0.1, 0.1 ], [ 0.3, 0.7,   0.1, 0.1 ],
        [ 0.4, 0.7,   0.1, 0.1 ], [ 0.5, 0.7,   0.1, 0.1 ],
        [ 0.6, 0.7,   0.1, 0.1 ], [ 0.7, 0.7,   0.1, 0.1 ],
        [ 0.8, 0.7,   0.1, 0.1 ], [ 0.9, 0.7,   0.1, 0.1 ],
        [ 0.0, 0.8,   0.1, 0.1 ], [ 0.1, 0.8,   0.1, 0.1 ],
        [ 0.2, 0.8,   0.1, 0.1 ], [ 0.3, 0.8,   0.1, 0.1 ],
        [ 0.4, 0.8,   0.1, 0.1 ], [ 0.5, 0.8,   0.1, 0.1 ],
        [ 0.6, 0.8,   0.1, 0.1 ], [ 0.7, 0.8,   0.1, 0.1 ],
        [ 0.8, 0.8,   0.1, 0.1 ], [ 0.9, 0.8,   0.1, 0.1 ],
        [ 0.0, 0.9,   0.1, 0.1 ], [ 0.1, 0.9,   0.1, 0.1 ],
        [ 0.2, 0.9,   0.1, 0.1 ], [ 0.3, 0.9,   0.1, 0.1 ],
        [ 0.4, 0.9,   0.1, 0.1 ], [ 0.5, 0.9,   0.1, 0.1 ],
        [ 0.6, 0.9,   0.1, 0.1 ], [ 0.7, 0.9,   0.1, 0.1 ],
        [ 0.8, 0.9,   0.1, 0.1 ], [ 0.9, 0.9,   0.1, 0.1 ],],
});

// interview
Object.assign(MixingLayoutType, {
    ml_interviewer_01_00 : [
        Object.assign([ 0.420, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
    ],

    ml_interviewer_02_00 : [
        Object.assign([ 0.340, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.500, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
    ],

    ml_interviewer_03_00 : [
        Object.assign([ 0.260, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.420, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.580, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
    ],

    ml_interviewer_04_00 : [
        Object.assign([ 0.180, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.340, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.500, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.660, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
    ],
    ml_interviewer_05_00 : [
        Object.assign([ 0.100, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.260, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.420, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.580, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.740, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
    ],

    ml_interviewer_06_00 : [
        Object.assign([ 0.020, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.180, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.340, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.500, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.660, 0.06, 0.16, 0.16 ], {pip: false, vip:true}),
        Object.assign([ 0.820, 0.06, 0.17, 0.16 ], {pip: false, vip:true}),
    ],
//interviewee
    ml_interviewee_01_00 : [
        [ 0.170, 0.340, 0.660, 0.660 ]
    ],
    ml_interviewee_02_00 : [
        [ 0.0, 0.420, 0.500, 0.500 ],
        [ 0.500, 0.420,	0.500, 0.500 ]
    ],
    ml_interviewee_03_00 : [
        [ 0.335, 0.340,	0.330, 0.330 ],
        [ 0.170, 0.670,	0.330, 0.330 ],
        [ 0.500, 0.670,	0.330, 0.330 ]
    ],
    ml_interviewee_04_00 : [
        [ 0.170, 0.340,	0.330, 0.330 ],
        [ 0.500, 0.340,	0.330, 0.330 ],
        [ 0.170, 0.670,	0.330, 0.330 ],
        [ 0.500, 0.670,	0.330, 0.330 ]
    ],
    ml_interviewee_05_00 : [
        [ 0.170, 0.340,	0.330, 0.330 ],
        [ 0.500, 0.340,	0.330, 0.330 ],
        [ 0.005, 0.670,	0.330, 0.330 ],
        [ 0.335, 0.670,	0.330, 0.330 ],
        [ 0.665, 0.670,	0.330, 0.330 ]
    ],
    ml_interviewee_06_00 : [
        [ 0.005, 0.340,	0.330, 0.330 ],
        [ 0.335, 0.340,	0.330, 0.330 ],
        [ 0.665, 0.340,	0.330, 0.330 ],
        [ 0.005, 0.670,	0.330, 0.330 ],
        [ 0.335, 0.670,	0.330, 0.330 ],
        [ 0.665, 0.670,	0.330, 0.330 ]
    ],
    ml_15_01: [
        Object.assign([ 0.0, 0.1,   0.5, 0.9], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.75,0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.55,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.75,0.55,   0.25, 0.45], {pip: false, clone: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1]
    ],
    ml_15_02: [
        Object.assign([ 0.0, 0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.25,0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.55,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.25,0.55,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.1,   0.5, 0.9], {pip: false, empty: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1]
    ],
    ml_18_00: [
        Object.assign([ 0.0, 0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.25,0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.75,0.1,   0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.55,  0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.25,0.55,  0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.55,  0.25, 0.45], {pip: false, clone: true}),
        Object.assign([ 0.75,0.55,  0.25, 0.45], {pip: false, clone: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1]
    ],
    ml_25_02: [
        Object.assign([ 0.0, 0.2,   0.5, 0.8], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.75,0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.75,0.6,   0.25, 0.4], {pip: false, clone: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1],
        [ 0.0, 0.1,   0.1, 0.1],
        [ 0.1, 0.1,   0.1, 0.1],
        [ 0.2, 0.1,   0.1, 0.1],
        [ 0.3, 0.1,   0.1, 0.1],
        [ 0.4, 0.1,   0.1, 0.1],
        [ 0.5, 0.1,   0.1, 0.1],
        [ 0.6, 0.1,   0.1, 0.1],
        [ 0.7, 0.1,   0.1, 0.1],
        [ 0.8, 0.1,   0.1, 0.1],
        [ 0.9, 0.1,   0.1, 0.1]
    ],
    ml_25_03: [
        Object.assign([ 0.0, 0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.25,0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.6,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.25,0.6,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.2,   0.5, 0.8], {pip: false, empty: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1],
        [ 0.0, 0.1,   0.1, 0.1],
        [ 0.1, 0.1,   0.1, 0.1],
        [ 0.2, 0.1,   0.1, 0.1],
        [ 0.3, 0.1,   0.1, 0.1],
        [ 0.4, 0.1,   0.1, 0.1],
        [ 0.5, 0.1,   0.1, 0.1],
        [ 0.6, 0.1,   0.1, 0.1],
        [ 0.7, 0.1,   0.1, 0.1],
        [ 0.8, 0.1,   0.1, 0.1],
        [ 0.9, 0.1,   0.1, 0.1]
    ],
    ml_28_01: [
        Object.assign([ 0.0, 0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.25,0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.75,0.2,   0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.6,  0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.25,0.6,  0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,  0.25, 0.4], {pip: false, clone: true}),
        Object.assign([ 0.75,0.6,  0.25, 0.4], {pip: false, clone: true}),
        [ 0.0, 0.0,   0.1, 0.1],
        [ 0.1, 0.0,   0.1, 0.1],
        [ 0.2, 0.0,   0.1, 0.1],
        [ 0.3, 0.0,   0.1, 0.1],
        [ 0.4, 0.0,   0.1, 0.1],
        [ 0.5, 0.0,   0.1, 0.1],
        [ 0.6, 0.0,   0.1, 0.1],
        [ 0.7, 0.0,   0.1, 0.1],
        [ 0.8, 0.0,   0.1, 0.1],
        [ 0.9, 0.0,   0.1, 0.1],
        [ 0.0, 0.1,   0.1, 0.1],
        [ 0.1, 0.1,   0.1, 0.1],
        [ 0.2, 0.1,   0.1, 0.1],
        [ 0.3, 0.1,   0.1, 0.1],
        [ 0.4, 0.1,   0.1, 0.1],
        [ 0.5, 0.1,   0.1, 0.1],
        [ 0.6, 0.1,   0.1, 0.1],
        [ 0.7, 0.1,   0.1, 0.1],
        [ 0.8, 0.1,   0.1, 0.1],
        [ 0.9, 0.1,   0.1, 0.1]
    ],
    ml_custom_film_hor_06_01: [
        [ 0.0,     0.0,   0.166, 1.0],
        [ 0.166,   0.0,   0.166, 1.0],
        [ 0.332,   0.0,   0.166, 1.0],
        [ 0.498,   0.0,   0.166, 1.0],
        [ 0.664,   0.0,   0.166, 1.0],
        [ 0.830,   0.0,   0.170, 1.0],
    ],
    ml_custom_film_hor_10_01: [
        [ 0.0, 0.0, 0.1, 1.0 ],
        [ 0.1, 0.0, 0.1, 1.0 ],
        [ 0.2, 0.0, 0.1, 1.0 ],
        [ 0.3, 0.0, 0.1, 1.0 ],
        [ 0.4, 0.0, 0.1, 1.0 ],
        [ 0.5, 0.0, 0.1, 1.0 ],
        [ 0.6, 0.0, 0.1, 1.0 ],
        [ 0.7, 0.0, 0.1, 1.0 ],
        [ 0.8, 0.0, 0.1, 1.0 ],
        [ 0.9, 0.0, 0.1, 1.0 ]
    ],
});

// film
Object.assign(MixingLayoutType, {
    ml_rg_main_empty_01_00 : [
       Object.assign([ 0.0, 0.0, 1.0, 1.0], {pip: false, empty: true})
    ],
    ml_rg_group_area_film_01_00: [
        [ 0.0, 0.0,   1.0, 1.0 ],
    ],
    ml_rg_group_area_film_02_00 : [
        [ 0.0, 0.0,	0.5, 1.0 ],
        [ 0.5, 0.0,	0.5, 1.0 ]
    ],
    ml_rg_group_area_film_03_00 : [
        [ 0.0, 0.0,	0.5, 0.5 ],
        [ 0.5, 0.0,	0.5, 0.5 ],
        [ 0.0, 0.5,	0.5, 0.5 ]
    ],
    ml_rg_group_area_film_04_00 : [
        [ 0.0, 0.0,	0.5, 0.5 ],
        [ 0.5, 0.0,	0.5, 0.5 ],
        [ 0.0, 0.5,	0.5, 0.5 ],
        [ 0.5, 0.5,	0.5, 0.5 ]
    ],
    ml_rg_group_area_film_05_00: [
        [ 0.0, 0.0,	0.5, 0.33 ],
        [ 0.5, 0.0,	0.5, 0.33 ],
        [ 0.0, 0.33, 0.5, 0.33 ],
        [ 0.5, 0.33, 0.5, 0.33 ],
        [ 0.0, 0.66, 0.5, 0.34 ]
    ],

    ml_rg_group_area_film_06_00: [
        [ 0.0, 0.0,	0.5, 0.33 ],
        [ 0.5, 0.0,	0.5, 0.33 ],
        [ 0.0, 0.33, 0.5, 0.33 ],
        [ 0.5, 0.33, 0.5, 0.33 ],
        [ 0.0, 0.66, 0.5, 0.34 ],
        [ 0.5, 0.66, 0.5, 0.34 ]
    ],

    ml_rg_group_area_film_07_00: [
        [ 0.0, 0.0,	0.5, 0.25 ],
        [ 0.5, 0.0,	0.5, 0.25 ],
        [ 0.0, 0.25, 0.5, 0.25 ],
        [ 0.5, 0.25, 0.5, 0.25 ],
        [ 0.0, 0.5,	0.5, 0.25 ],
        [ 0.5, 0.5,	0.5, 0.25 ],
        [ 0.0, 0.75, 0.5, 0.25 ]
    ],

    ml_rg_group_area_film_08_00: [
        [ 0.0, 0.0,	0.5, 0.25 ],
        [ 0.5, 0.0,	0.5, 0.25 ],
        [ 0.0, 0.25, 0.5, 0.25 ],
        [ 0.5, 0.25, 0.5, 0.25 ],
        [ 0.0, 0.5,	0.5, 0.25 ],
        [ 0.5, 0.5,	0.5, 0.25 ],
        [ 0.0, 0.75, 0.5, 0.25 ],
        [ 0.5, 0.75, 0.5, 0.25 ]
    ],

    ml_rg_group_area_film_09_00: [
        [ 0.0, 0.0,	0.5, 0.2 ],
        [ 0.5, 0.0,	0.5, 0.2 ],
        [ 0.0, 0.2,	0.5, 0.2 ],
        [ 0.5, 0.2,	0.5, 0.2 ],
        [ 0.0, 0.4,	0.5, 0.2 ],
        [ 0.5, 0.4,	0.5, 0.2 ],
        [ 0.0, 0.6,	0.5, 0.2 ],
        [ 0.5, 0.6,	0.5, 0.2 ],
        [ 0.0, 0.8,	0.5, 0.2 ]
    ],

    ml_rg_group_area_film_10_00: [
        [ 0.0,		0.0,	0.5, 0.2 ],
        [ 0.5,		0.0,	0.5, 0.2 ],
        [ 0.0,		0.2,	0.5, 0.2 ],
        [ 0.5,		0.2,	0.5, 0.2 ],
        [ 0.0,		0.4,	0.5, 0.2 ],
        [ 0.5,		0.4,	0.5, 0.2 ],
        [ 0.0,		0.6,	0.5, 0.2 ],
        [ 0.5,		0.6,	0.5, 0.2 ],
        [ 0.0,		0.8,	0.5, 0.2 ],
        [ 0.5,		0.8,	0.5, 0.2 ]
    ],

    ml_rg_group_area_01_00 : [ [ 0.02, 0, 0.96, 1 ] ],
    ml_rg_group_area_02_00 : [ [ 0.02, 0, 0.47, 1 ], [ 0.51, 0, 0.47, 1 ] ],
    ml_rg_group_area_03_00: [ [ 0.265, 0, 0.47, 0.5 ],
        [ 0.02, 0.5, 0.47, 0.5 ], [ 0.51, 0.5, 0.47, 0.5 ] ],
    ml_rg_group_area_03_01: [ [ 0.265, 0, 0.47, 0.5 ],
        [ 0.02, 0.5, 0.47, 0.5 ], [ 0.51, 0.5, 0.47, 0.5 ] ],
    ml_rg_group_area_04_00: [ [ 0.02, 0, 0.47, 0.5 ],
        [ 0.51, 0, 0.47, 0.5 ], [ 0.02, 0.5, 0.47, 0.5 ],
        [ 0.51, 0.5, 0.47, 0.5 ] ],
    ml_rg_group_area_04_01: [ [ 0.02, 0, 0.47, 0.5 ],
        [ 0.51, 0, 0.47, 0.5 ], [ 0.02, 0.5, 0.47, 0.5 ],
        [ 0.51, 0.5, 0.47, 0.5 ] ],
    ml_rg_group_area_05_00: [
        [ 0.18,    0.0,   0.30, 0.5 ],
        [ 0.52,    0.0,   0.30, 0.5 ],
        [ 0.03,    0.5,   0.30, 0.5 ],
        [ 0.35,    0.5,   0.30, 0.5 ],
        [ 0.67,    0.5,   0.30, 0.5 ]
    ],
    ml_rg_group_area_06_00: [
        [ 0.03,    0.0,   0.30, 0.5 ],
        [ 0.35,    0.0,   0.30, 0.5 ],
        [ 0.67,    0.0,   0.30, 0.5 ],
        [ 0.03,    0.5,   0.30, 0.5 ],
        [ 0.35,    0.5,   0.30, 0.5 ],
        [ 0.67,    0.5,   0.30, 0.5 ]
    ],
    ml_rg_group_area_07_00: [
        [ 0.18,    0.01,  0.30, 0.33 ],
        [ 0.52,    0.01,  0.30, 0.33 ],
        [ 0.03,    0.34,  0.30, 0.33 ],
        [ 0.35,    0.34,  0.30, 0.33 ],
        [ 0.67,    0.34,  0.30, 0.33 ],

        [ 0.18,    0.67,  0.30, 0.33 ],
        [ 0.52,    0.67,  0.30, 0.33 ]
    ],
    ml_rg_group_area_08_00: [
        [ 0.03,    0.01,  0.30, 0.33 ],
        [ 0.35,    0.01,  0.30, 0.33 ],
        [ 0.67,    0.01,  0.30, 0.33 ],
        [ 0.18,    0.34,  0.30, 0.33 ],
        [ 0.52,    0.34,  0.30, 0.33 ],
        [ 0.03,    0.67,  0.30, 0.33 ],
        [ 0.35,    0.67,  0.30, 0.33 ],
        [ 0.67,    0.67,  0.30, 0.33 ]
    ],
    ml_rg_group_area_09_00: [
        [ 0.03,    0.01,  0.30, 0.33 ],
        [ 0.35,    0.01,  0.30, 0.33 ],
        [ 0.67,    0.01,  0.30, 0.33 ],
        [ 0.03,    0.34,  0.30, 0.33 ],
        [ 0.35,    0.34,  0.30, 0.33 ],
        [ 0.67,    0.34,  0.30, 0.33 ],
        [ 0.03,    0.67,  0.30, 0.33 ],
        [ 0.35,    0.67,  0.30, 0.33 ],
        [ 0.67,    0.67,  0.30, 0.33 ]
    ],
    ml_rg_group_area_10_00: [
        [ 0.125,   0.01,  0.248, 0.33 ],
        [ 0.375,   0.01,  0.248, 0.33 ],
        [ 0.625,   0.01,  0.248, 0.33 ],
        [ 0.001,   0.34,  0.248, 0.33 ],
        [ 0.251,   0.34,  0.248, 0.33 ],
        [ 0.501,   0.34,  0.248, 0.33 ],
        [ 0.751,   0.34,  0.248, 0.33 ],
        [ 0.125,   0.67,  0.248, 0.33 ],
        [ 0.375,   0.67,  0.248, 0.33 ],
        [ 0.625,   0.67,  0.248, 0.33 ]
    ],
});

// clone
Object.assign(MixingLayoutType, {
    ml_clone_04_04: [
        Object.assign([ 0.0,   0.0, 0.250, 0.250],	{vip:true}),
        [ 0.250, 0.0, 0.250, 0.250 ],
        [ 0.500, 0.0, 0.250, 0.250 ],
        [ 0.750, 0.0, 0.250, 0.250 ],
        Object.assign([ 0.0,   0.250, 0.250, 0.750], {pip: false, clone: true}),
        Object.assign([ 0.250, 0.250, 0.250, 0.750], {pip: false, clone: true}),
        Object.assign([ 0.500, 0.250, 0.250, 0.750], {pip: false, clone: true}),
        Object.assign([ 0.750, 0.250, 0.250, 0.750], {pip: false, clone: true})
    ],

    ml_clone_22_01: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,   0.180,   1.0, 0.820 ], {pip: false, clone: true}),
    ],
    ml_clone_22_02: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,   0.180,   0.5, 0.820 ], {pip: false, clone: true}),
        Object.assign([ 0.5,   0.180,   0.5, 0.820 ], {pip: false, clone: true}),
    ],
    ml_clone_22_04: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,   0.180,   0.5, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,   0.180,   0.5, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.0,   0.590,   0.5, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,   0.590,   0.5, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_22_05: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.180,   0.5, 0.820 ], {pip: false, clone: true}),

        Object.assign([ 0.5,  0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.590,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.590,   0.25, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_22_06: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.180,   0.33, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.180,   0.33, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.180,   0.34, 0.410 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.590,   0.33, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.590,   0.33, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.590,   0.34, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_22_08: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.180,   0.25, 0.410 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.590,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.590,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.590,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.590,   0.25, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_24_01: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,   0.166,   1.0, 0.834 ], {pip: false, clone: true}),
    ],
    ml_clone_24_02: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0, 0.166,   0.5, 0.834 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.166,   0.5, 0.834 ], {pip: false, clone: true}),
    ],
    ml_clone_24_04: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0, 0.166,   0.5, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.166,   0.5, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.583,   0.5, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.583,   0.5, 0.417 ], {pip: false, clone: true}),
    ],
    ml_clone_24_05: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,  0.166,   0.5, 0.834 ], {pip: false, clone: true}),

        Object.assign([ 0.5,  0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.583,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.583,   0.25, 0.417 ], {pip: false, clone: true}),
    ],
    ml_clone_24_06: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,  0.166,   0.33, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.166,   0.33, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.166,   0.34, 0.417 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.583,   0.33, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.583,   0.33, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.583,   0.34, 0.417 ], {pip: false, clone: true}),
    ],
    ml_clone_24_08: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,  0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.166,   0.25, 0.417 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.583,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.583,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.583,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.583,   0.25, 0.417 ], {pip: false, clone: true}),
    ],
    ml_clone_empty_22_01: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.180,   1.0, 0.820 ], {pip: false, empty: true}),
    ],
    ml_clone_le_22_02: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.180,   0.5, 0.820 ], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.180,   0.5, 0.820 ], {pip: false, clone: true}),
    ],
    ml_clone_le_22_05: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.180,   0.5, 0.820 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.180,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.590,   0.25, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.590,   0.25, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_le_22_07: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.180,   0.5, 0.820 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.180,  0.166, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.180,  0.166, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.180,  0.168, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.590,  0.166, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.590,  0.166, 0.410 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.590,  0.168, 0.410 ], {pip: false, clone: true}),
    ],
    ml_clone_empty_24_01: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0, 0.166,   1.0, 0.834 ], {pip: false, empty: true}),
    ],
    ml_clone_le_24_02: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0, 0.166,   0.5, 0.834 ], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.166,   0.5, 0.834 ], {pip: false, clone: true}),
    ],
    ml_clone_le_24_05: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,  0.166,   0.5, 0.834 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.166,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.583,   0.25, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.583,   0.25, 0.417 ], {pip: false, clone: true}),
    ],
    ml_clone_le_24_07: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0,  0.166,   0.5, 0.834 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.166,  0.166, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.166,  0.166, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.166,  0.168, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.583,  0.166, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.583,  0.166, 0.417 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.583,  0.168, 0.417 ], {pip: false, clone: true}),
    ],
    ml_screen_share_11_01 : [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],
    
        Object.assign([ 0.0, 0.090,   1.0, 0.910 ],  {pip: false, screenshare: true})
    ],
    ml_screen_share_22_01: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        [ 0.0,   0.090,   0.090, 0.090 ],
        [ 0.090, 0.090,   0.090, 0.090 ],
        [ 0.180, 0.090,   0.090, 0.090 ],
        [ 0.270, 0.090,   0.090, 0.090 ],
        [ 0.360, 0.090,   0.090, 0.090 ],
        [ 0.450, 0.090,   0.090, 0.090 ],
        [ 0.540, 0.090,   0.090, 0.090 ],
        [ 0.630, 0.090,   0.090, 0.090 ],
        [ 0.720, 0.090,   0.090, 0.090 ],
        [ 0.810, 0.090,   0.090, 0.090 ],
        [ 0.900, 0.090,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.180,   1.0, 0.820],  {pip: false, screenshare: true})
    ],
    ml_screen_share_24_01: [
        Object.assign([ 0.0,   0.0,   0.083, 0.083 ], {pip: false, vip: true}),
        Object.assign([ 0.083, 0.0,   0.083, 0.083 ], {pip: false, vad: true}),
        [ 0.166, 0.0,   0.083, 0.083 ],
        [ 0.249, 0.0,   0.083, 0.083 ],
        [ 0.332, 0.0,   0.083, 0.083 ],
        [ 0.415, 0.0,   0.083, 0.083 ],
        [ 0.498, 0.0,   0.083, 0.083 ],
        [ 0.581, 0.0,   0.083, 0.083 ],
        [ 0.664, 0.0,   0.083, 0.083 ],
        [ 0.747, 0.0,   0.083, 0.083 ],
        [ 0.830, 0.0,   0.083, 0.083 ],
        [ 0.913, 0.0,   0.087, 0.083 ],

        [ 0.0,   0.083,   0.083, 0.083 ],
        [ 0.083, 0.083,   0.083, 0.083 ],
        [ 0.166, 0.083,   0.083, 0.083 ],
        [ 0.249, 0.083,   0.083, 0.083 ],
        [ 0.332, 0.083,   0.083, 0.083 ],
        [ 0.415, 0.083,   0.083, 0.083 ],
        [ 0.498, 0.083,   0.083, 0.083 ],
        [ 0.581, 0.083,   0.083, 0.083 ],
        [ 0.664, 0.083,   0.083, 0.083 ],
        [ 0.747, 0.083,   0.083, 0.083 ],
        [ 0.830, 0.083,   0.083, 0.083 ],
        [ 0.913, 0.083,   0.087, 0.083 ],

        Object.assign([ 0.0, 0.166,   1.0, 0.834],  {pip: false, screenshare: true})
    ],
    ml_clone_10_01: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],
        Object.assign([ 0.0, 0.1,   1.0, 0.9 ], {pip: false, clone: true}),
    ],
    ml_clone_10_02: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],
        Object.assign([ 0.0, 0.1,   0.5, 0.9 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.1,   0.5, 0.9 ], {pip: false, clone: true}),
    ],
    ml_clone_10_04: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],
        Object.assign([ 0.0, 0.1,   0.5, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.1,   0.5, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.55,  0.5, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.55,  0.5, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_10_05: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.5, 0.9 ], {pip: false, clone: true}),

        Object.assign([ 0.5,  0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.55,  0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.55,  0.25, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_10_06: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.33, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.33,0.1,   0.33, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.66,0.1,   0.34, 0.45 ], {pip: false, clone: true}),

        Object.assign([ 0.0, 0.55,  0.33, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.33,0.55,  0.33, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.55, 0.34, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_10_08: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.25,0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.1,   0.25, 0.45 ], {pip: false, clone: true}),

        Object.assign([ 0.0, 0.55,  0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.25,0.55,  0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.55,  0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.55,  0.25, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_11_01: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,   0.090,   1.0, 0.910 ], {pip: false, clone: true}),
    ],
    ml_clone_11_02: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.090,   0.5, 0.910 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.090,   0.5, 0.910 ], {pip: false, clone: true}),
    ],
    ml_clone_11_04: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.090,   0.5, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.090,   0.5, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.545,   0.5, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.545,   0.5, 0.455 ], {pip: false, clone: true}),
    ],
    ml_clone_11_05: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.090,   0.5, 0.910 ], {pip: false, clone: true}),

        Object.assign([ 0.5,  0.090,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.090,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.545,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.545,   0.25, 0.455 ], {pip: false, clone: true}),
    ],
    ml_clone_11_06: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.090,   0.33, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.090,   0.33, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.090,   0.34, 0.455 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.545,   0.33, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.33, 0.545,   0.33, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.66, 0.545,   0.34, 0.455 ], {pip: false, clone: true}),
    ],
    ml_clone_11_08: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.090,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.090,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.090,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.090,   0.25, 0.455 ], {pip: false, clone: true}),

        Object.assign([ 0.0,  0.545,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.25, 0.545,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.545,   0.25, 0.455 ], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.545,   0.25, 0.455 ], {pip: false, clone: true}),
    ],
    ml_clone_20_01: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   1.0, 0.8 ], {pip: false, clone: true}),
    ],
    ml_clone_20_02: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5, 0.8 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.2,   0.5, 0.8 ], {pip: false, clone: true}),
    ],
    ml_clone_20_04: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.2,   0.5, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.0, 0.6,   0.5, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,   0.5, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_20_05: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5, 0.8 ], {pip: false, clone: true}),

        Object.assign([ 0.5, 0.2,  0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.2,  0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,  0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.6,  0.25, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_20_06: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],


        Object.assign([ 0.0, 0.2,   0.33, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.33,0.2,   0.33, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.66,0.2,   0.34, 0.4 ], {pip: false, clone: true}),

        Object.assign([ 0.0, 0.6,   0.33, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.33,0.6,   0.33, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.66,0.6,   0.34, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_20_08: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],


        Object.assign([ 0.0, 0.2,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.25,0.2,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.2,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.2,   0.25, 0.4 ], {pip: false, clone: true}),

        Object.assign([ 0.0, 0.6,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.25,0.6,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.6,   0.25, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_le_10_02: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.5, 0.9 ], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.1,   0.5, 0.9 ], {pip: false, clone: true}),
    ],
    ml_clone_le_10_05: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.5,  0.9 ], {pip: false, empty: true}),

        Object.assign([ 0.5, 0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.1,   0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.55,  0.25, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.55,  0.25, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_le_10_07: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   0.5,  0.9 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.1,  0.166, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.1,  0.166, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.1,  0.168, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.55, 0.166, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.55, 0.166, 0.45 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.55, 0.168, 0.45 ], {pip: false, clone: true}),
    ],
    ml_clone_le_11_02: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.090,   0.5, 0.910], {pip:false, empty: true}),
        Object.assign([ 0.5, 0.090,   0.5, 0.910], {pip: false, clone: true}),
    ],
    ml_clone_le_11_05: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.090,   0.5, 0.910], {pip:false, empty: true}),

        Object.assign([ 0.5,  0.090,   0.25, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.090,   0.25, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.545,   0.25, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.75, 0.545,   0.25, 0.455], {pip: false, clone: true}),
    ],
    ml_clone_le_11_07: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090], {pip: false, vad: true}),
        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0,  0.090,   0.5, 0.910], {pip:false, empty: true}),

        Object.assign([ 0.5,  0.090,  0.166, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.666,0.090,  0.166, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.832,0.090,  0.168, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.545,  0.166, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.666,0.545,  0.166, 0.455], {pip: false, clone: true}),
        Object.assign([ 0.832,0.545,  0.168, 0.455], {pip: false, clone: true}),
    ],
    ml_clone_le_20_02: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5, 0.8 ], {pip: false, empty: true}),
        Object.assign([ 0.5, 0.2,   0.5, 0.8 ], {pip: false, clone: true}),
    ],
    ml_clone_le_20_05: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5,  0.8 ], {pip: false, empty: true}),

        Object.assign([ 0.5, 0.2,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.2,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5, 0.6,   0.25, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.75,0.6,   0.25, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_le_20_07: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   0.5,  0.8 ], {pip: false, empty: true}),

        Object.assign([ 0.5,  0.2,  0.166, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.2,  0.166, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.2,  0.168, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.5,  0.6,  0.166, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.666,0.6,  0.166, 0.4 ], {pip: false, clone: true}),
        Object.assign([ 0.832,0.6,  0.168, 0.4 ], {pip: false, clone: true}),
    ],
    ml_clone_empty_10_01: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.1,   1.0, 0.9 ], {pip: false, empty: true}),
    ],
    ml_clone_empty_11_01: [
        Object.assign([ 0.0,   0.0,   0.090, 0.090 ], {pip: false, vip: true}),
        Object.assign([ 0.090, 0.0,   0.090, 0.090 ], {pip: false, vad: true}),

        [ 0.180, 0.0,   0.090, 0.090 ],
        [ 0.270, 0.0,   0.090, 0.090 ],
        [ 0.360, 0.0,   0.090, 0.090 ],
        [ 0.450, 0.0,   0.090, 0.090 ],
        [ 0.540, 0.0,   0.090, 0.090 ],
        [ 0.630, 0.0,   0.090, 0.090 ],
        [ 0.720, 0.0,   0.090, 0.090 ],
        [ 0.810, 0.0,   0.090, 0.090 ],
        [ 0.900, 0.0,   0.100, 0.090 ],

        Object.assign([ 0.0, 0.090,   1.0, 0.910 ], {pip: false, empty: true}),
    ],
    ml_clone_empty_20_01: [
        [ 0.0, 0.0,   0.1, 0.1 ],
        [ 0.1, 0.0,   0.1, 0.1 ],
        [ 0.2, 0.0,   0.1, 0.1 ],
        [ 0.3, 0.0,   0.1, 0.1 ],
        [ 0.4, 0.0,   0.1, 0.1 ],
        [ 0.5, 0.0,   0.1, 0.1 ],
        [ 0.6, 0.0,   0.1, 0.1 ],
        [ 0.7, 0.0,   0.1, 0.1 ],
        [ 0.8, 0.0,   0.1, 0.1 ],
        [ 0.9, 0.0,   0.1, 0.1 ],

        [ 0.0, 0.1,   0.1, 0.1 ],
        [ 0.1, 0.1,   0.1, 0.1 ],
        [ 0.2, 0.1,   0.1, 0.1 ],
        [ 0.3, 0.1,   0.1, 0.1 ],
        [ 0.4, 0.1,   0.1, 0.1 ],
        [ 0.5, 0.1,   0.1, 0.1 ],
        [ 0.6, 0.1,   0.1, 0.1 ],
        [ 0.7, 0.1,   0.1, 0.1 ],
        [ 0.8, 0.1,   0.1, 0.1 ],
        [ 0.9, 0.1,   0.1, 0.1 ],

        Object.assign([ 0.0, 0.2,   1.0, 0.8 ], {pip: false, empty: true}),
    ],
});

//clone
Object.assign(MixingLayoutType, {
    ml_rg_main_vip_11_00: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ],
        Object.assign([ 0, 0.1, 1, 0.9 ], {pip: false, vip:true})
    ],
    ml_rg_main_vip_11_01: [ [ 0, 0.9, 0.1, 0.1 ], [ 0.1, 0.9, 0.1, 0.1 ],
        [ 0.2, 0.9, 0.1, 0.1 ], [ 0.3, 0.9, 0.1, 0.1 ],
        [ 0.4, 0.9, 0.1, 0.1 ], [ 0.5, 0.9, 0.1, 0.1 ],
        [ 0.6, 0.9, 0.1, 0.1 ], [ 0.7, 0.9, 0.1, 0.1 ],
        [ 0.8, 0.9, 0.1, 0.1 ], [ 0.9, 0.9, 0.1, 0.1 ],
        Object.assign([ 0, 0, 1, 0.9 ], {pip: false, vip: true})
    ],
    ml_rg_main_vip_16_00: [ [ 0, 0, 0.066, 0.066 ],
        [ 0.066, 0, 0.066, 0.066 ], [ 0.132, 0, 0.066, 0.066 ],
        [ 0.198, 0, 0.066, 0.066 ], [ 0.264, 0, 0.066, 0.066 ],
        [ 0.33, 0, 0.066, 0.066 ], [ 0.396, 0, 0.066, 0.066 ],
        [ 0.462, 0, 0.066, 0.066 ], [ 0.528, 0, 0.066, 0.066 ],
        [ 0.594, 0, 0.066, 0.066 ], [ 0.66, 0, 0.066, 0.066 ],
        [ 0.726, 0, 0.066, 0.066 ], [ 0.792, 0, 0.066, 0.066 ],
        [ 0.858, 0, 0.066, 0.066 ], [ 0.924, 0, 0.076, 0.066 ],
        [ 0, 0.066, 1, 0.934 ] ],
    ml_rg_main_vip_16_01: [ [ 0, 0.934, 0.066, 0.066 ],
        [ 0.066, 0.934, 0.066, 0.066 ], [ 0.132, 0.934, 0.066, 0.066 ],
        [ 0.198, 0.934, 0.066, 0.066 ], [ 0.264, 0.934, 0.066, 0.066 ],
        [ 0.33, 0.934, 0.066, 0.066 ], [ 0.396, 0.934, 0.066, 0.066 ],
        [ 0.462, 0.934, 0.066, 0.066 ], [ 0.528, 0.934, 0.066, 0.066 ],
        [ 0.594, 0.934, 0.066, 0.066 ], [ 0.66, 0.934, 0.066, 0.066 ],
        [ 0.726, 0.934, 0.066, 0.066 ], [ 0.792, 0.934, 0.066, 0.066 ],
        [ 0.858, 0.934, 0.066, 0.066 ], [ 0.924, 0.934, 0.076, 0.066 ],
        [ 0, 0, 1, 0.868 ] ],
    ml_rg_main_vip_17_00: [ [ 0, 0, 0.0625, 0.0625 ],
        [ 0.0625, 0, 0.0625, 0.0625 ], [ 0.125, 0, 0.0625, 0.0625 ],
        [ 0.1875, 0, 0.0625, 0.0625 ], [ 0.25, 0, 0.0625, 0.0625 ],
        [ 0.3125, 0, 0.0625, 0.0625 ], [ 0.375, 0, 0.0625, 0.0625 ],
        [ 0.4375, 0, 0.0625, 0.0625 ], [ 0.5, 0, 0.0625, 0.0625 ],
        [ 0.5625, 0, 0.0625, 0.0625 ], [ 0.625, 0, 0.0625, 0.0625 ],
        [ 0.6875, 0, 0.0625, 0.0625 ], [ 0.75, 0, 0.0625, 0.0625 ],
        [ 0.8125, 0, 0.0625, 0.0625 ], [ 0.875, 0, 0.0625, 0.0625 ],
        [ 0.9375, 0, 0.0625, 0.0625 ], [ 0, 0.0625, 1, 0.9375 ] ],
    ml_rg_main_vip_17_01: [ [ 0, 0.9375, 0.0625, 0.0625 ],
        [ 0.0625, 0.9375, 0.0625, 0.0625 ],
        [ 0.125, 0.9375, 0.0625, 0.0625 ],
        [ 0.1875, 0.9375, 0.0625, 0.0625 ],
        [ 0.25, 0.9375, 0.0625, 0.0625 ],
        [ 0.3125, 0.9375, 0.0625, 0.0625 ],
        [ 0.375, 0.9375, 0.0625, 0.0625 ],
        [ 0.4375, 0.9375, 0.0625, 0.0625 ],
        [ 0.5, 0.9375, 0.0625, 0.0625 ],
        [ 0.5625, 0.9375, 0.0625, 0.0625 ],
        [ 0.625, 0.9375, 0.0625, 0.0625 ],
        [ 0.6875, 0.9375, 0.0625, 0.0625 ],
        [ 0.75, 0.9375, 0.0625, 0.0625 ],
        [ 0.8125, 0.9375, 0.0625, 0.0625 ],
        [ 0.875, 0.9375, 0.0625, 0.0625 ],
        [ 0.9375, 0.9375, 0.0625, 0.0625 ], [ 0, 0, 1, 0.9375 ] ],
    ml_rg_main_vip_21_00: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ], [ 0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ], [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ], [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ], [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ], [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ],
        Object.assign([ 0, 0.2, 1, 0.8 ], {pip: false, vip:true})
    ],
    ml_rg_main_vip_21_01: [ [ 0, 0.8, 0.1, 0.1 ], [ 0.1, 0.8, 0.1, 0.1 ],
        [ 0.2, 0.8, 0.1, 0.1 ], [ 0.3, 0.8, 0.1, 0.1 ],
        [ 0.4, 0.8, 0.1, 0.1 ], [ 0.5, 0.8, 0.1, 0.1 ],
        [ 0.6, 0.8, 0.1, 0.1 ], [ 0.7, 0.8, 0.1, 0.1 ],
        [ 0.8, 0.8, 0.1, 0.1 ], [ 0.9, 0.8, 0.1, 0.1 ],
        [ 0, 0.9, 0.1, 0.1 ], [ 0.1, 0.9, 0.1, 0.1 ],
        [ 0.2, 0.9, 0.1, 0.1 ], [ 0.3, 0.9, 0.1, 0.1 ],
        [ 0.4, 0.9, 0.1, 0.1 ], [ 0.5, 0.9, 0.1, 0.1 ],
        [ 0.6, 0.9, 0.1, 0.1 ], [ 0.7, 0.9, 0.1, 0.1 ],
        [ 0.8, 0.9, 0.1, 0.1 ], [ 0.9, 0.9, 0.1, 0.1 ],
        Object.assign([ 0, 0, 1, 0.8 ], {pip: false, vip: true})
    ],
    ml_rg_main_vip_31_00: [ [ 0, 0, 0.066, 0.066 ],
        [ 0.066, 0, 0.066, 0.066 ], [ 0.132, 0, 0.066, 0.066 ],
        [ 0.198, 0, 0.066, 0.066 ], [ 0.264, 0, 0.066, 0.066 ],
        [ 0.33, 0, 0.066, 0.066 ], [ 0.396, 0, 0.066, 0.066 ],
        [ 0.462, 0, 0.066, 0.066 ], [ 0.528, 0, 0.066, 0.066 ],
        [ 0.594, 0, 0.066, 0.066 ], [ 0.66, 0, 0.066, 0.066 ],
        [ 0.726, 0, 0.066, 0.066 ], [ 0.792, 0, 0.066, 0.066 ],
        [ 0.858, 0, 0.066, 0.066 ], [ 0.924, 0, 0.076, 0.066 ],
        [ 0, 0.066, 0.066, 0.066 ], [ 0.066, 0.066, 0.066, 0.066 ],
        [ 0.132, 0.066, 0.066, 0.066 ], [ 0.198, 0.066, 0.066, 0.066 ],
        [ 0.264, 0.066, 0.066, 0.066 ], [ 0.33, 0.066, 0.066, 0.066 ],
        [ 0.396, 0.066, 0.066, 0.066 ], [ 0.462, 0.066, 0.066, 0.066 ],
        [ 0.528, 0.066, 0.066, 0.066 ], [ 0.594, 0.066, 0.066, 0.066 ],
        [ 0.66, 0.066, 0.066, 0.066 ], [ 0.726, 0.066, 0.066, 0.066 ],
        [ 0.792, 0.066, 0.066, 0.066 ], [ 0.858, 0.066, 0.066, 0.066 ],
        [ 0.924, 0.066, 0.076, 0.066 ],
        Object.assign([ 0, 0.132, 1, 0.868 ], {pip: false, vip: true})
    ],
    ml_rg_main_vip_31_01: [ [ 0, 0.868, 0.066, 0.066 ],
        [ 0.066, 0.868, 0.066, 0.066 ], [ 0.132, 0.868, 0.066, 0.066 ],
        [ 0.198, 0.868, 0.066, 0.066 ], [ 0.264, 0.868, 0.066, 0.066 ],
        [ 0.33, 0.868, 0.066, 0.066 ], [ 0.396, 0.868, 0.066, 0.066 ],
        [ 0.462, 0.868, 0.066, 0.066 ], [ 0.528, 0.868, 0.066, 0.066 ],
        [ 0.594, 0.868, 0.066, 0.066 ], [ 0.66, 0.868, 0.066, 0.066 ],
        [ 0.726, 0.868, 0.066, 0.066 ], [ 0.792, 0.868, 0.066, 0.066 ],
        [ 0.858, 0.868, 0.066, 0.066 ], [ 0.924, 0.868, 0.076, 0.066 ],
        [ 0, 0.934, 0.066, 0.066 ], [ 0.066, 0.934, 0.066, 0.066 ],
        [ 0.132, 0.934, 0.066, 0.066 ], [ 0.198, 0.934, 0.066, 0.066 ],
        [ 0.264, 0.934, 0.066, 0.066 ], [ 0.33, 0.934, 0.066, 0.066 ],
        [ 0.396, 0.934, 0.066, 0.066 ], [ 0.462, 0.934, 0.066, 0.066 ],
        [ 0.528, 0.934, 0.066, 0.066 ], [ 0.594, 0.934, 0.066, 0.066 ],
        [ 0.66, 0.934, 0.066, 0.066 ], [ 0.726, 0.934, 0.066, 0.066 ],
        [ 0.792, 0.934, 0.066, 0.066 ], [ 0.858, 0.934, 0.066, 0.066 ],
        [ 0.924, 0.934, 0.076, 0.066 ],
        Object.assign([ 0, 0, 1, 0.868 ], {pip: false, vip: true})
    ],
    ml_rg_main_vip_31_02: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ], [ 0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ], [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ], [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ], [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ], [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ], [ 0, 0.2, 0.1, 0.1 ],
        [ 0.1, 0.2, 0.1, 0.1 ], [ 0.2, 0.2, 0.1, 0.1 ],
        [ 0.3, 0.2, 0.1, 0.1 ], [ 0.4, 0.2, 0.1, 0.1 ],
        [ 0.5, 0.2, 0.1, 0.1 ], [ 0.6, 0.2, 0.1, 0.1 ],
        [ 0.7, 0.2, 0.1, 0.1 ], [ 0.8, 0.2, 0.1, 0.1 ],
        [ 0.9, 0.2, 0.1, 0.1 ],
        Object.assign([ 0, 0.3, 1, 0.7 ], {pip: false, vip:true})
    ],
    ml_rg_main_vip_33_00: [ [ 0, 0, 0.0625, 0.0625 ],
        [ 0.0625, 0, 0.0625, 0.0625 ], [ 0.125, 0, 0.0625, 0.0625 ],
        [ 0.1875, 0, 0.0625, 0.0625 ], [ 0.25, 0, 0.0625, 0.0625 ],
        [ 0.3125, 0, 0.0625, 0.0625 ], [ 0.375, 0, 0.0625, 0.0625 ],
        [ 0.4375, 0, 0.0625, 0.0625 ], [ 0.5, 0, 0.0625, 0.0625 ],
        [ 0.5625, 0, 0.0625, 0.0625 ], [ 0.625, 0, 0.0625, 0.0625 ],
        [ 0.6875, 0, 0.0625, 0.0625 ], [ 0.75, 0, 0.0625, 0.0625 ],
        [ 0.8125, 0, 0.0625, 0.0625 ], [ 0.875, 0, 0.0625, 0.0625 ],
        [ 0.9375, 0, 0.0625, 0.0625 ], [ 0, 0.0625, 0.0625, 0.0625 ],
        [ 0.0625, 0.0625, 0.0625, 0.0625 ],
        [ 0.125, 0.0625, 0.0625, 0.0625 ],
        [ 0.1875, 0.0625, 0.0625, 0.0625 ],
        [ 0.25, 0.0625, 0.0625, 0.0625 ],
        [ 0.3125, 0.0625, 0.0625, 0.0625 ],
        [ 0.375, 0.0625, 0.0625, 0.0625 ],
        [ 0.4375, 0.0625, 0.0625, 0.0625 ],
        [ 0.5, 0.0625, 0.0625, 0.0625 ],
        [ 0.5625, 0.0625, 0.0625, 0.0625 ],
        [ 0.625, 0.0625, 0.0625, 0.0625 ],
        [ 0.6875, 0.0625, 0.0625, 0.0625 ],
        [ 0.75, 0.0625, 0.0625, 0.0625 ],
        [ 0.8125, 0.0625, 0.0625, 0.0625 ],
        [ 0.875, 0.0625, 0.0625, 0.0625 ],
        [ 0.9375, 0.0625, 0.0625, 0.0625 ], [ 0, 0.125, 1, 0.875 ] ],
    ml_rg_main_vip_33_01: [ [ 0, 0.875, 0.0625, 0.0625 ],
        [ 0.0625, 0.875, 0.0625, 0.0625 ],
        [ 0.125, 0.875, 0.0625, 0.0625 ],
        [ 0.1875, 0.875, 0.0625, 0.0625 ], [ 0.25, 0.875, 0.0625, 0.0625 ],
        [ 0.3125, 0.875, 0.0625, 0.0625 ],
        [ 0.375, 0.875, 0.0625, 0.0625 ],
        [ 0.4375, 0.875, 0.0625, 0.0625 ], [ 0.5, 0.875, 0.0625, 0.0625 ],
        [ 0.5625, 0.875, 0.0625, 0.0625 ],
        [ 0.625, 0.875, 0.0625, 0.0625 ],
        [ 0.6875, 0.875, 0.0625, 0.0625 ], [ 0.75, 0.875, 0.0625, 0.0625 ],
        [ 0.8125, 0.875, 0.0625, 0.0625 ],
        [ 0.875, 0.875, 0.0625, 0.0625 ],
        [ 0.9375, 0.875, 0.0625, 0.0625 ], [ 0, 0.9375, 0.0625, 0.0625 ],
        [ 0.0625, 0.9375, 0.0625, 0.0625 ],
        [ 0.125, 0.9375, 0.0625, 0.0625 ],
        [ 0.1875, 0.9375, 0.0625, 0.0625 ],
        [ 0.25, 0.9375, 0.0625, 0.0625 ],
        [ 0.3125, 0.9375, 0.0625, 0.0625 ],
        [ 0.375, 0.9375, 0.0625, 0.0625 ],
        [ 0.4375, 0.9375, 0.0625, 0.0625 ],
        [ 0.5, 0.9375, 0.0625, 0.0625 ],
        [ 0.5625, 0.9375, 0.0625, 0.0625 ],
        [ 0.625, 0.9375, 0.0625, 0.0625 ],
        [ 0.6875, 0.9375, 0.0625, 0.0625 ],
        [ 0.75, 0.9375, 0.0625, 0.0625 ],
        [ 0.8125, 0.9375, 0.0625, 0.0625 ],
        [ 0.875, 0.9375, 0.0625, 0.0625 ],
        [ 0.9375, 0.9375, 0.0625, 0.0625 ], [ 0, 0, 1, 0.875 ] ],
    ml_rg_main_vip_vad_12_00: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ], [ 0, 0.1, 0.5, 0.9 ],
        [ 0.5, 0.1, 0.5, 0.9 ] ],
    ml_rg_main_vip_vad_12_01: [ [ 0, 0.9, 0.1, 0.1 ],
        [ 0.1, 0.9, 0.1, 0.1 ], [ 0.2, 0.9, 0.1, 0.1 ],
        [ 0.3, 0.9, 0.1, 0.1 ], [ 0.4, 0.9, 0.1, 0.1 ],
        [ 0.5, 0.9, 0.1, 0.1 ], [ 0.6, 0.9, 0.1, 0.1 ],
        [ 0.7, 0.9, 0.1, 0.1 ], [ 0.8, 0.9, 0.1, 0.1 ],
        [ 0.9, 0.9, 0.1, 0.1 ], [ 0, 0, 0.5, 0.9 ], [ 0.5, 0, 0.5, 0.9 ] ],
    ml_rg_main_vip_vad_17_00: [ [ 0, 0, 0.066, 0.066 ],
        [ 0.066, 0, 0.066, 0.066 ], [ 0.132, 0, 0.066, 0.066 ],
        [ 0.198, 0, 0.066, 0.066 ], [ 0.264, 0, 0.066, 0.066 ],
        [ 0.33, 0, 0.066, 0.066 ], [ 0.396, 0, 0.066, 0.066 ],
        [ 0.462, 0, 0.066, 0.066 ], [ 0.528, 0, 0.066, 0.066 ],
        [ 0.594, 0, 0.066, 0.066 ], [ 0.66, 0, 0.066, 0.066 ],
        [ 0.726, 0, 0.066, 0.066 ], [ 0.792, 0, 0.066, 0.066 ],
        [ 0.858, 0, 0.066, 0.066 ], [ 0.924, 0, 0.076, 0.066 ],
        [ 0, 0.066, 0.5, 0.934 ], [ 0.5, 0.066, 0.5, 0.934 ] ],
    ml_rg_main_vip_vad_17_01: [ [ 0, 0.934, 0.066, 0.066 ],
        [ 0.066, 0.934, 0.066, 0.066 ], [ 0.132, 0.934, 0.066, 0.066 ],
        [ 0.198, 0.934, 0.066, 0.066 ], [ 0.264, 0.934, 0.066, 0.066 ],
        [ 0.33, 0.934, 0.066, 0.066 ], [ 0.396, 0.934, 0.066, 0.066 ],
        [ 0.462, 0.934, 0.066, 0.066 ], [ 0.528, 0.934, 0.066, 0.066 ],
        [ 0.594, 0.934, 0.066, 0.066 ], [ 0.66, 0.934, 0.066, 0.066 ],
        [ 0.726, 0.934, 0.066, 0.066 ], [ 0.792, 0.934, 0.066, 0.066 ],
        [ 0.858, 0.934, 0.066, 0.066 ], [ 0.924, 0.934, 0.076, 0.066 ],
        [ 0, 0, 0.5, 0.934 ], [ 0.5, 0, 0.5, 0.934 ] ],
    ml_rg_main_vip_vad_18_00: [ [ 0, 0, 0.0625, 0.0625 ],
        [ 0.0625, 0, 0.0625, 0.0625 ], [ 0.125, 0, 0.0625, 0.0625 ],
        [ 0.1875, 0, 0.0625, 0.0625 ], [ 0.25, 0, 0.0625, 0.0625 ],
        [ 0.3125, 0, 0.0625, 0.0625 ], [ 0.375, 0, 0.0625, 0.0625 ],
        [ 0.4375, 0, 0.0625, 0.0625 ], [ 0.5, 0, 0.0625, 0.0625 ],
        [ 0.5625, 0, 0.0625, 0.0625 ], [ 0.625, 0, 0.0625, 0.0625 ],
        [ 0.6875, 0, 0.0625, 0.0625 ], [ 0.75, 0, 0.0625, 0.0625 ],
        [ 0.8125, 0, 0.0625, 0.0625 ], [ 0.875, 0, 0.0625, 0.0625 ],
        [ 0.9375, 0, 0.0625, 0.0625 ], [ 0, 0.0625, 0.5, 0.9375 ],
        [ 0.5, 0.0625, 0.5, 0.9375 ] ],
    ml_rg_main_vip_vad_18_01: [ [ 0, 0.9375, 0.0625, 0.0625 ],
        [ 0.0625, 0.9375, 0.0625, 0.0625 ],
        [ 0.125, 0.9375, 0.0625, 0.0625 ],
        [ 0.1875, 0.9375, 0.0625, 0.0625 ],
        [ 0.25, 0.9375, 0.0625, 0.0625 ],
        [ 0.3125, 0.9375, 0.0625, 0.0625 ],
        [ 0.375, 0.9375, 0.0625, 0.0625 ],
        [ 0.4375, 0.9375, 0.0625, 0.0625 ],
        [ 0.5, 0.9375, 0.0625, 0.0625 ],
        [ 0.5625, 0.9375, 0.0625, 0.0625 ],
        [ 0.625, 0.9375, 0.0625, 0.0625 ],
        [ 0.6875, 0.9375, 0.0625, 0.0625 ],
        [ 0.75, 0.9375, 0.0625, 0.0625 ],
        [ 0.8125, 0.9375, 0.0625, 0.0625 ],
        [ 0.875, 0.9375, 0.0625, 0.0625 ],
        [ 0.9375, 0.9375, 0.0625, 0.0625 ], [ 0, 0, 0.5, 0.9375 ],
        [ 0.5, 0, 0.5, 0.9375 ] ],
    ml_rg_main_vip_vad_22_00: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ], [ 0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ], [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ], [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ], [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ], [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ], [ 0, 0.2, 0.5, 0.8 ],
        [ 0.5, 0.2, 0.5, 0.8 ] ],
    ml_rg_main_vip_vad_22_01: [ [ 0, 0.8, 0.1, 0.1 ],
        [ 0.1, 0.8, 0.1, 0.1 ], [ 0.2, 0.8, 0.1, 0.1 ],
        [ 0.3, 0.8, 0.1, 0.1 ], [ 0.4, 0.8, 0.1, 0.1 ],
        [ 0.5, 0.8, 0.1, 0.1 ], [ 0.6, 0.8, 0.1, 0.1 ],
        [ 0.7, 0.8, 0.1, 0.1 ], [ 0.8, 0.8, 0.1, 0.1 ],
        [ 0.9, 0.8, 0.1, 0.1 ], [ 0, 0.9, 0.1, 0.1 ],
        [ 0.1, 0.9, 0.1, 0.1 ], [ 0.2, 0.9, 0.1, 0.1 ],
        [ 0.3, 0.9, 0.1, 0.1 ], [ 0.4, 0.9, 0.1, 0.1 ],
        [ 0.5, 0.9, 0.1, 0.1 ], [ 0.6, 0.9, 0.1, 0.1 ],
        [ 0.7, 0.9, 0.1, 0.1 ], [ 0.8, 0.9, 0.1, 0.1 ],
        [ 0.9, 0.9, 0.1, 0.1 ], [ 0, 0, 0.5, 0.8 ], [ 0.5, 0, 0.5, 0.8 ] ],
    ml_rg_main_vip_vad_32_00: [ [ 0, 0, 0.066, 0.066 ],
        [ 0.066, 0, 0.066, 0.066 ], [ 0.132, 0, 0.066, 0.066 ],
        [ 0.198, 0, 0.066, 0.066 ], [ 0.264, 0, 0.066, 0.066 ],
        [ 0.33, 0, 0.066, 0.066 ], [ 0.396, 0, 0.066, 0.066 ],
        [ 0.462, 0, 0.066, 0.066 ], [ 0.528, 0, 0.066, 0.066 ],
        [ 0.594, 0, 0.066, 0.066 ], [ 0.66, 0, 0.066, 0.066 ],
        [ 0.726, 0, 0.066, 0.066 ], [ 0.792, 0, 0.066, 0.066 ],
        [ 0.858, 0, 0.066, 0.066 ], [ 0.924, 0, 0.076, 0.066 ],
        [ 0, 0.066, 0.066, 0.066 ], [ 0.066, 0.066, 0.066, 0.066 ],
        [ 0.132, 0.066, 0.066, 0.066 ], [ 0.198, 0.066, 0.066, 0.066 ],
        [ 0.264, 0.066, 0.066, 0.066 ], [ 0.33, 0.066, 0.066, 0.066 ],
        [ 0.396, 0.066, 0.066, 0.066 ], [ 0.462, 0.066, 0.066, 0.066 ],
        [ 0.528, 0.066, 0.066, 0.066 ], [ 0.594, 0.066, 0.066, 0.066 ],
        [ 0.66, 0.066, 0.066, 0.066 ], [ 0.726, 0.066, 0.066, 0.066 ],
        [ 0.792, 0.066, 0.066, 0.066 ], [ 0.858, 0.066, 0.066, 0.066 ],
        [ 0.924, 0.066, 0.076, 0.066 ], [ 0, 0.132, 0.5, 0.868 ],
        [ 0.5, 0.132, 0.5, 0.868 ] ],
    ml_rg_main_vip_vad_32_01: [ [ 0, 0.868, 0.066, 0.066 ],
        [ 0.066, 0.868, 0.066, 0.066 ], [ 0.132, 0.868, 0.066, 0.066 ],
        [ 0.198, 0.868, 0.066, 0.066 ], [ 0.264, 0.868, 0.066, 0.066 ],
        [ 0.33, 0.868, 0.066, 0.066 ], [ 0.396, 0.868, 0.066, 0.066 ],
        [ 0.462, 0.868, 0.066, 0.066 ], [ 0.528, 0.868, 0.066, 0.066 ],
        [ 0.594, 0.868, 0.066, 0.066 ], [ 0.66, 0.868, 0.066, 0.066 ],
        [ 0.726, 0.868, 0.066, 0.066 ], [ 0.792, 0.868, 0.066, 0.066 ],
        [ 0.858, 0.868, 0.066, 0.066 ], [ 0.924, 0.868, 0.076, 0.066 ],
        [ 0, 0.934, 0.066, 0.066 ], [ 0.066, 0.934, 0.066, 0.066 ],
        [ 0.132, 0.934, 0.066, 0.066 ], [ 0.198, 0.934, 0.066, 0.066 ],
        [ 0.264, 0.934, 0.066, 0.066 ], [ 0.33, 0.934, 0.066, 0.066 ],
        [ 0.396, 0.934, 0.066, 0.066 ], [ 0.462, 0.934, 0.066, 0.066 ],
        [ 0.528, 0.934, 0.066, 0.066 ], [ 0.594, 0.934, 0.066, 0.066 ],
        [ 0.66, 0.934, 0.066, 0.066 ], [ 0.726, 0.934, 0.066, 0.066 ],
        [ 0.792, 0.934, 0.066, 0.066 ], [ 0.858, 0.934, 0.066, 0.066 ],
        [ 0.924, 0.934, 0.076, 0.066 ], [ 0, 0, 0.5, 0.868 ],
        [ 0.5, 0, 0.5, 0.868 ] ],
    ml_rg_main_vip_vad_32_02: [ [ 0, 0, 0.1, 0.1 ], [ 0.1, 0, 0.1, 0.1 ],
        [ 0.2, 0, 0.1, 0.1 ], [ 0.3, 0, 0.1, 0.1 ], [ 0.4, 0, 0.1, 0.1 ],
        [ 0.5, 0, 0.1, 0.1 ], [ 0.6, 0, 0.1, 0.1 ], [ 0.7, 0, 0.1, 0.1 ],
        [ 0.8, 0, 0.1, 0.1 ], [ 0.9, 0, 0.1, 0.1 ], [ 0, 0.1, 0.1, 0.1 ],
        [ 0.1, 0.1, 0.1, 0.1 ], [ 0.2, 0.1, 0.1, 0.1 ],
        [ 0.3, 0.1, 0.1, 0.1 ], [ 0.4, 0.1, 0.1, 0.1 ],
        [ 0.5, 0.1, 0.1, 0.1 ], [ 0.6, 0.1, 0.1, 0.1 ],
        [ 0.7, 0.1, 0.1, 0.1 ], [ 0.8, 0.1, 0.1, 0.1 ],
        [ 0.9, 0.1, 0.1, 0.1 ], [ 0, 0.2, 0.1, 0.1 ],
        [ 0.1, 0.2, 0.1, 0.1 ], [ 0.2, 0.2, 0.1, 0.1 ],
        [ 0.3, 0.2, 0.1, 0.1 ], [ 0.4, 0.2, 0.1, 0.1 ],
        [ 0.5, 0.2, 0.1, 0.1 ], [ 0.6, 0.2, 0.1, 0.1 ],
        [ 0.7, 0.2, 0.1, 0.1 ], [ 0.8, 0.2, 0.1, 0.1 ],
        [ 0.9, 0.2, 0.1, 0.1 ], [ 0, 0.3, 0.5, 0.7 ],
        [ 0.5, 0.3, 0.5, 0.7 ] ],
    ml_rg_main_vip_vad_34_00: [ [ 0, 0, 0.0625, 0.0625 ],
        [ 0.0625, 0, 0.0625, 0.0625 ], [ 0.125, 0, 0.0625, 0.0625 ],
        [ 0.1875, 0, 0.0625, 0.0625 ], [ 0.25, 0, 0.0625, 0.0625 ],
        [ 0.3125, 0, 0.0625, 0.0625 ], [ 0.375, 0, 0.0625, 0.0625 ],
        [ 0.4375, 0, 0.0625, 0.0625 ], [ 0.5, 0, 0.0625, 0.0625 ],
        [ 0.5625, 0, 0.0625, 0.0625 ], [ 0.625, 0, 0.0625, 0.0625 ],
        [ 0.6875, 0, 0.0625, 0.0625 ], [ 0.75, 0, 0.0625, 0.0625 ],
        [ 0.8125, 0, 0.0625, 0.0625 ], [ 0.875, 0, 0.0625, 0.0625 ],
        [ 0.9375, 0, 0.0625, 0.0625 ], [ 0, 0.0625, 0.0625, 0.0625 ],
        [ 0.0625, 0.0625, 0.0625, 0.0625 ],
        [ 0.125, 0.0625, 0.0625, 0.0625 ],
        [ 0.1875, 0.0625, 0.0625, 0.0625 ],
        [ 0.25, 0.0625, 0.0625, 0.0625 ],
        [ 0.3125, 0.0625, 0.0625, 0.0625 ],
        [ 0.375, 0.0625, 0.0625, 0.0625 ],
        [ 0.4375, 0.0625, 0.0625, 0.0625 ],
        [ 0.5, 0.0625, 0.0625, 0.0625 ],
        [ 0.5625, 0.0625, 0.0625, 0.0625 ],
        [ 0.625, 0.0625, 0.0625, 0.0625 ],
        [ 0.6875, 0.0625, 0.0625, 0.0625 ],
        [ 0.75, 0.0625, 0.0625, 0.0625 ],
        [ 0.8125, 0.0625, 0.0625, 0.0625 ],
        [ 0.875, 0.0625, 0.0625, 0.0625 ],
        [ 0.9375, 0.0625, 0.0625, 0.0625 ], [ 0, 0.125, 0.5, 0.875 ],
        [ 0.5, 0.125, 0.5, 0.875 ] ],
    ml_rg_main_vip_vad_34_01: [ [ 0, 0.875, 0.0625, 0.0625 ],
        [ 0.0625, 0.875, 0.0625, 0.0625 ],
        [ 0.125, 0.875, 0.0625, 0.0625 ],
        [ 0.1875, 0.875, 0.0625, 0.0625 ], [ 0.25, 0.875, 0.0625, 0.0625 ],
        [ 0.3125, 0.875, 0.0625, 0.0625 ],
        [ 0.375, 0.875, 0.0625, 0.0625 ],
        [ 0.4375, 0.875, 0.0625, 0.0625 ], [ 0.5, 0.875, 0.0625, 0.0625 ],
        [ 0.5625, 0.875, 0.0625, 0.0625 ],
        [ 0.625, 0.875, 0.0625, 0.0625 ],
        [ 0.6875, 0.875, 0.0625, 0.0625 ], [ 0.75, 0.875, 0.0625, 0.0625 ],
        [ 0.8125, 0.875, 0.0625, 0.0625 ],
        [ 0.875, 0.875, 0.0625, 0.0625 ],
        [ 0.9375, 0.875, 0.0625, 0.0625 ], [ 0, 0.9375, 0.0625, 0.0625 ],
        [ 0.0625, 0.9375, 0.0625, 0.0625 ],
        [ 0.125, 0.9375, 0.0625, 0.0625 ],
        [ 0.1875, 0.9375, 0.0625, 0.0625 ],
        [ 0.25, 0.9375, 0.0625, 0.0625 ],
        [ 0.3125, 0.9375, 0.0625, 0.0625 ],
        [ 0.375, 0.9375, 0.0625, 0.0625 ],
        [ 0.4375, 0.9375, 0.0625, 0.0625 ],
        [ 0.5, 0.9375, 0.0625, 0.0625 ],
        [ 0.5625, 0.9375, 0.0625, 0.0625 ],
        [ 0.625, 0.9375, 0.0625, 0.0625 ],
        [ 0.6875, 0.9375, 0.0625, 0.0625 ],
        [ 0.75, 0.9375, 0.0625, 0.0625 ],
        [ 0.8125, 0.9375, 0.0625, 0.0625 ],
        [ 0.875, 0.9375, 0.0625, 0.0625 ],
        [ 0.9375, 0.9375, 0.0625, 0.0625 ], [ 0, 0, 0.5, 0.875 ],
        [ 0.5, 0, 0.5, 0.875 ] ],
})

Object.freeze(MixingLayoutType);

export const roomCallMixerLayout = new RoomCallMixerLayout();
